<div class="pv-shell">
  <!-- Overlay de carregamento em modo edição (também cobre a ação de status
       silenciosa — Cancelar/Estornar disparados pela Lista — para o
       vendedor nunca ver o formulário "por trás" nesse fluxo). -->
  <div *ngIf="carregandoEdicao || acaoStatusGravando"
       style="position:fixed;inset:0;background:rgba(0,0,0,.35);z-index:9999;display:flex;align-items:center;justify-content:center">
    <div style="background:#fff;border-radius:12px;padding:28px 36px;display:flex;align-items:center;gap:14px;font-size:15px;color:#374151">
      <app-loading-indicator size="inline"></app-loading-indicator>
      {{ acaoStatusGravando ? 'Atualizando status do pedido...' : 'Carregando pedido para edicao...' }}
    </div>
  </div>
  <!-- Overlay padrão do sistema (igual ao Demonstrativo de Vendas) ao
       clicar em Salvar — trava a tela inteira com uma bolinha girando. -->
  <div *ngIf="salvando()" class="loading-overlay">
    <app-loading-indicator></app-loading-indicator>
  </div>
  <!-- Mensagem central de feedback rápido (ex.: "NCM copiado com
       sucesso!"). Estilo 100% inline de propósito — não depende do .css
       externo do componente, então não tem como falhar por causa de
       cache/ordem de carregamento do CSS. Fica bem no meio da tela,
       aparece e some sozinha (ver _exibirCopiarFeedback() no .ts). -->
  <div *ngIf="mensagemCentral"
       style="position:fixed;inset:0;z-index:2000000;display:flex;align-items:center;justify-content:center;pointer-events:none">
    <div style="background:rgba(30,41,59,0.85);color:#fff;padding:8px 18px;border-radius:8px;font-size:12.5px;font-weight:500;box-shadow:0 4px 16px rgba(0,0,0,0.2);text-align:center">
      {{ mensagemCentral }}
    </div>
  </div>
  <div class="container">

    <!-- Modal de Confirmação Sair da Tela -->
    <div class="excel-confirm-overlay" *ngIf="confirmacaoSairAberta" (click)="cancelarSair()">
      <div class="excel-confirm-modal" (click)="$event.stopPropagation()">
        <div class="excel-confirm-icon" style="background:#fef2f2; color:#dc2626;">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
        </div>
        <h3 class="excel-confirm-titulo">Atenção!</h3>
        <p class="excel-confirm-msg">
          Deseja realmente sair da tela de VENDA?
        </p>
        <div class="excel-confirm-footer">
          <button type="button" class="modal-btn" (click)="cancelarSair()">Cancelar</button>
          <button type="button" class="modal-btn-primary" style="background:#dc2626; border-color:#dc2626;" (click)="confirmarSair()">
            Sair mesmo assim
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Confirmação Troca de Empresa (menu) -->
    <div class="excel-confirm-overlay" *ngIf="confirmacaoTrocaEmpresaAberta" (click)="cancelarTrocaEmpresa()">
      <div class="excel-confirm-modal" (click)="$event.stopPropagation()">
        <div class="excel-confirm-icon" style="background:#fef2f2; color:#dc2626;">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
        </div>
        <h3 class="excel-confirm-titulo">Atenção!</h3>
        <p class="excel-confirm-msg">
          Deseja realmente mudar a empresa? A quantidade Disponível dos itens do pedido será recalculada para a nova empresa.
        </p>
        <div class="excel-confirm-footer">
          <button type="button" class="modal-btn" (click)="cancelarTrocaEmpresa()">Cancelar</button>
          <button type="button" class="modal-btn-primary" style="background:#dc2626; border-color:#dc2626;" (click)="confirmarTrocaEmpresa()">
            Mudar mesmo assim
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Confirmação Atualizar Cotação -->
    <div class="excel-confirm-overlay" *ngIf="confirmacaoAtualizarCotacaoAberta" (click)="cancelarAtualizarCotacao()">
      <div class="excel-confirm-modal" (click)="$event.stopPropagation()">
        <div class="excel-confirm-icon" style="background:#eff6ff; color:#2563eb;">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="23 4 23 10 17 10"></polyline>
            <polyline points="1 20 1 14 7 14"></polyline>
            <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"></path>
          </svg>
        </div>
        <h3 class="excel-confirm-titulo">Atualizar COTAÇÃO DO DÓLAR?</h3>
        <p class="excel-confirm-msg">
          Deseja atualizar a <strong>cotação do dólar</strong> para a mais recente cadastrada? Os valores dependentes da cotação serão recalculados.
        </p>
        <div class="excel-confirm-footer">
          <button type="button" class="modal-btn" (click)="cancelarAtualizarCotacao()">Não</button>
          <button type="button" class="modal-btn-primary" (click)="confirmarAtualizarCotacao()">
            Sim, atualizar COTAÇÃO
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Confirmação Atualizar Preço de Venda (ALTCOT) -->
    <div class="excel-confirm-overlay" *ngIf="confirmacaoAtualizarPrecoAberta" (click)="cancelarAtualizarPrecoVenda()">
      <div class="excel-confirm-modal" (click)="$event.stopPropagation()">
        <div class="excel-confirm-icon" style="background:#fffbeb; color:#d97706;">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
          </svg>
        </div>
        <h3 class="excel-confirm-titulo">Pedido antigo</h3>
        <p class="excel-confirm-msg">
          Este pedido tem Data de Emissão com mais de {{ diasConfiguradosAltcot }} {{ diasConfiguradosAltcot === 1 ? 'dia' : 'dias' }}. Deseja atualizar a <strong>cotação do dólar</strong> para a mais recente cadastrada e recalcular os valores dependentes dela?
        </p>
        <div class="excel-confirm-footer">
          <button type="button" class="modal-btn" (click)="cancelarAtualizarPrecoVenda()">Não</button>
          <button type="button" class="modal-btn-primary" (click)="confirmarAtualizarPrecoVenda()">
            Sim, atualizar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Confirmação Itens com Preço Desatualizado (ALTPRECO) -->
    <div class="excel-confirm-overlay" *ngIf="confirmacaoAtualizarPrecosDesatualizadosAberta" (click)="cancelarAtualizarPrecosDesatualizados()">
      <div class="excel-confirm-modal" (click)="$event.stopPropagation()">
        <div class="excel-confirm-icon" style="background:#fffbeb; color:#d97706;">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
          </svg>
        </div>
        <h3 class="excel-confirm-titulo">Itens com preço desatualizado</h3>
        <p class="excel-confirm-msg">
          Este pedido tem Data de Emissão com mais de {{ diasConfiguradosAltpreco }} {{ diasConfiguradosAltpreco === 1 ? 'dia' : 'dias' }} e {{ qtdItensPrecoDesatualizado }} {{ qtdItensPrecoDesatualizado === 1 ? 'item está' : 'itens estão' }} com o preço desatualizado em relação ao catálogo. Deseja atualizar {{ qtdItensPrecoDesatualizado === 1 ? 'o preço deste item' : 'o preço destes itens' }} para os valores atuais do catálogo?
        </p>
        <div class="excel-confirm-footer">
          <button type="button" class="modal-btn" (click)="cancelarAtualizarPrecosDesatualizados()">Não</button>
          <button type="button" class="modal-btn-primary" (click)="confirmarAtualizarPrecosDesatualizados()">
            Sim, atualizar
          </button>
        </div>
      </div>
    </div>

    <!-- ── CABEÇALHO + ABAS FIXOS NO TOPO ── pedido do usuário: essa faixa
         inteira (título/botões + abas + Total Pedido/Dólar EUA) fica
         "grudada" no topo enquanto o resto do conteúdo rola por baixo.
         position:sticky (não fixed) porque assim ela respeita a largura/
         posição normal do .container, sem precisar calcular left/right
         manualmente — só "gruda" quando alcança o topo do scroll do
         .content-shell (ver gateway.component.html/css). -->
    <div class="pv-header-fixo">
    <!-- ── PAGE HEADER ── -->
    <div class="page-header">
      <div class="page-header-icon"
           [style.background]="empresaState.selecionada === '1' ? 'rgba(255,255,255,0.15)' : empresaState.cor"
           [style.color]="empresaState.selecionada === '1' ? '#fff' : pageHeaderTextColor">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/>
          <path d="M16 10a4 4 0 0 1-8 0"/>
        </svg>
      </div>
      <div style="flex:1">
        <h1>{{ forcarFinalizarAoSalvar ? 'Finalizar Venda #' + nunotaAtual : (somenteCabecalho ? 'Editar Dados da Venda #' + nunotaAtual : (modoEdicao ? 'Editar Pedido #' + nunotaAtual : 'Novo Pedido de Venda')) }}</h1>
        <p>{{ forcarFinalizarAoSalvar ? 'Confira os dados antes de finalizar — ao salvar, o status muda para Finalizado' : (somenteCabecalho ? 'Cliente, endereço, aeronave, tipo de negociação e observações' : (modoEdicao ? 'Altere os dados e salve' : 'Preencha os dados e itens do pedido')) }}</p>
      </div>
      <div style="display: flex; gap: 10px; align-items: center;">
        <button type="button" class="btn-salvar-header"
                *ngIf="!modoSomenteLeitura || (somenteCabecalho && abaPrincipalAtiva === 'itensDesconto')"
                [disabled]="salvando() || !formularioValido" (click)="salvar()">
          <svg *ngIf="!salvando()" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
            <polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/>
          </svg>
          <app-loading-indicator *ngIf="salvando()" size="inline"></app-loading-indicator>
          {{ salvando() ? 'Salvando...' : (forcarFinalizarAoSalvar ? 'Finalizar Venda' : (somenteCabecalho ? 'Salvar Alterações' : (modoEdicao ? 'Atualizar Pedido' : 'Salvar Pedido'))) }}
        </button>

        <button type="button"
          style="background:rgba(255,255,255,0.15);border:1px solid rgba(255,255,255,0.3);color:#fff;border-radius:8px;padding:8px 16px;cursor:pointer;display:flex;align-items:center;gap:6px;font-size:13px;font-weight: 500;"
          (click)="onVoltarClick()">
          <svg *ngIf="!somenteCabecalho" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
          {{ somenteCabecalho ? 'Fechar' : 'Voltar' }}
        </button>
      </div>
    </div>

    <!-- ── ALERTA ── -->
    <div *ngIf="alerta" class="alerta" [ngClass]="'alerta-' + alerta.tipo">
      <svg *ngIf="alerta.tipo === 'sucesso'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
      <svg *ngIf="alerta.tipo === 'erro'"   xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
      <svg *ngIf="alerta.tipo === 'aviso'"  xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
      {{ alerta.mensagem }}
    </div>

    <!-- ── ABAS PRINCIPAIS ── -->
    <div class="pv-abas-principais">
      <button type="button" class="pv-aba-principal"
              [class.ativa]="abaPrincipalAtiva === 'dados'"
              (click)="abaPrincipalAtiva = 'dados'">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
        </svg>
        Dados do Pedido
      </button>
      <button type="button" class="pv-aba-principal"
              [class.ativa]="abaPrincipalAtiva === 'enderecos'"
              [disabled]="!clienteSelecionado && !mostrarEnderecos"
              (click)="abaPrincipalAtiva = 'enderecos'">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
        </svg>
        Entrega
      </button>
      <button type="button" class="pv-aba-principal" *ngIf="somenteCabecalho"
              [class.ativa]="abaPrincipalAtiva === 'observacoes'"
              (click)="abaPrincipalAtiva = 'observacoes'">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
        Observações
      </button>
      <button type="button" class="pv-aba-principal" *ngIf="somenteCabecalho"
              [class.ativa]="abaPrincipalAtiva === 'itensDesconto'"
              (click)="abaPrincipalAtiva = 'itensDesconto'">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/>
          <line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/>
          <line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
        </svg>
        Desconto dos Itens
        <span *ngIf="itensPreenchiidos > 0" class="pv-aba-badge">{{ itensPreenchiidos }}</span>
      </button>
      <button type="button" class="pv-aba-principal" *ngIf="!somenteCabecalho"
              [class.ativa]="abaPrincipalAtiva === 'itens'"
              (click)="irParaItens()">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/>
          <line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/>
          <line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
        </svg>
        Itens do Pedido
        <span *ngIf="itensPreenchiidos > 0" class="pv-aba-badge">{{ itensPreenchiidos }}</span>
      </button>
      <button type="button" class="pv-aba-principal" *ngIf="!somenteCabecalho"
              [class.ativa]="abaPrincipalAtiva === 'comissoes'"
              (click)="abaPrincipalAtiva = 'comissoes'">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/>
        </svg>
        Comissionado
        <span *ngIf="comissoes.length > 0" class="pv-aba-badge">{{ comissoes.length }}</span>
      </button>

      <!-- Cotação do dólar + Total do Pedido (só aparece com itens lançados,
           atualiza em tempo real conforme os itens são adicionados/alterados) -->
      <div *ngIf="cotacaoValorNumerico > 0 && !somenteCabecalho" class="cotacao-totais-wrap">
        <div class="total-pedido-pill" *ngIf="itensPreenchiidos > 0"
             title="Total do Pedido já incluindo os impostos (IPI e ICMS-ST)">
          <div class="total-pedido-pill-item" *ngIf="subtotalUsd > 0">
            <span class="total-pedido-pill-label">Total Pedido U$</span>
            <span class="total-pedido-pill-valor">$ {{ formatarDecimal(totalPedidoUsd) }}</span>
          </div>
          <div class="total-pedido-pill-item">
            <span class="total-pedido-pill-label">Total Pedido R$</span>
            <span class="total-pedido-pill-valor">{{ formatarMoeda(totalPedido) }}</span>
          </div>
        </div>

      <div class="cotacao-pill" [class.cotacao-pill-clicavel]="cotacaoEditavel" (click)="solicitarAtualizarCotacao()" title="Atualizar cotação do dólar">
        <svg width="38" height="38" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" class="cotacao-flag-svg">
          <defs>
            <clipPath id="fc-circle"><circle cx="18" cy="18" r="17"/></clipPath>
            <clipPath id="fc-left"><rect x="0" y="0" width="18" height="36"/></clipPath>
            <clipPath id="fc-right"><rect x="18" y="0" width="18" height="36"/></clipPath>
          </defs>
          <g clip-path="url(#fc-circle)">
            <!-- US Flag (left) -->
            <g clip-path="url(#fc-left)">
              <rect width="36" height="36" fill="#B22234"/>
              <rect y="2.77" width="36" height="2.77" fill="#FFF"/>
              <rect y="8.31" width="36" height="2.77" fill="#FFF"/>
              <rect y="13.85" width="36" height="2.77" fill="#FFF"/>
              <rect y="19.38" width="36" height="2.77" fill="#FFF"/>
              <rect y="24.92" width="36" height="2.77" fill="#FFF"/>
              <rect y="30.46" width="36" height="2.77" fill="#FFF"/>
              <rect width="10" height="15.4" fill="#3C3B6E"/>
              <circle cx="2" cy="2" r="0.85" fill="#FFF"/>
              <circle cx="5" cy="2" r="0.85" fill="#FFF"/>
              <circle cx="8" cy="2" r="0.85" fill="#FFF"/>
              <circle cx="3.5" cy="4.5" r="0.85" fill="#FFF"/>
              <circle cx="6.5" cy="4.5" r="0.85" fill="#FFF"/>
              <circle cx="2" cy="7" r="0.85" fill="#FFF"/>
              <circle cx="5" cy="7" r="0.85" fill="#FFF"/>
              <circle cx="8" cy="7" r="0.85" fill="#FFF"/>
              <circle cx="3.5" cy="9.5" r="0.85" fill="#FFF"/>
              <circle cx="6.5" cy="9.5" r="0.85" fill="#FFF"/>
              <circle cx="2" cy="12" r="0.85" fill="#FFF"/>
              <circle cx="5" cy="12" r="0.85" fill="#FFF"/>
              <circle cx="8" cy="12" r="0.85" fill="#FFF"/>
            </g>
            <!-- Brazil Flag (right) -->
            <g clip-path="url(#fc-right)">
              <rect x="18" width="18" height="36" fill="#009C3B"/>
              <polygon points="18,5 33,18 18,31 3,18" fill="#FFDF00"/>
              <circle cx="18" cy="18" r="6" fill="#002776"/>
              <path d="M12.5,19.5 A6,6 0 0,0 23.5,19.5" fill="none" stroke="white" stroke-width="0.9"/>
              <circle cx="15" cy="17" r="0.85" fill="white"/>
              <circle cx="18" cy="15.5" r="0.85" fill="white"/>
              <circle cx="21" cy="17" r="0.85" fill="white"/>
              <circle cx="16" cy="19.5" r="0.85" fill="white"/>
              <circle cx="20" cy="19.5" r="0.85" fill="white"/>
            </g>
            <line x1="18" y1="0" x2="18" y2="36" stroke="rgba(255,255,255,0.35)" stroke-width="0.7"/>
          </g>
          <circle cx="18" cy="18" r="16.5" fill="none" stroke="rgba(0,0,0,0.12)" stroke-width="1.5"/>
        </svg>
        <div class="cotacao-info">
          <span class="cotacao-label">Dólar EUA</span>
          <span class="cotacao-valor">R$ {{ cotacaoValorNumerico | number:'1.2-2':'pt-BR' }}</span>
        </div>
      </div>
      </div>
    </div>
    </div><!-- /.pv-header-fixo -->

    <fieldset [disabled]="modoSomenteLeitura" style="border:none; padding:0; margin:0; min-width: 0;">
    <!-- ── CARD CABEÇALHO ── -->
    <div *ngIf="abaPrincipalAtiva === 'dados'" class="card">
      <div class="card-title">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
        </svg>
        Dados do Pedido
      </div>

      <div class="form-grid">

        <!-- GRID 2 LINHAS: linha1=Cliente+Prioridade+Despachar / linha2=FatImediato+Tipo+TipoOp+DataEmissão+DataNeg -->
        <!-- As colunas 2 e 3 do grid são compartilhadas pelas duas linhas, garantindo alinhamento vertical
             entre Prioridade↔DataEmissão e Despachar↔DataNegociação. -->
        <div class="form-group span-2 cab-linhas-combinadas">

          <!-- LINHA 1, COL 1: Cliente -->
          <div class="cliente-autocomplete campo-cliente-reduzido cab-col1-row1">

            <!-- Banner de crédito -->
            <div *ngIf="creditoCarregando" class="credito-banner credito-loading">
              <app-loading-indicator size="inline"></app-loading-indicator> Consultando crédito...
            </div>
            <div *ngIf="!creditoCarregando && creditoInfo" class="credito-banner"
                 [class.credito-ok]="creditoDisponivel"
                 [class.credito-bloqueado]="!creditoDisponivel">
              <div class="credito-linha-principal">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line *ngIf="creditoDisponivel" x1="9" y1="12" x2="12" y2="15"/><line *ngIf="creditoDisponivel" x1="12" y1="15" x2="17" y2="9"/>
                  <line *ngIf="!creditoDisponivel" x1="15" y1="9" x2="9" y2="15"/><line *ngIf="!creditoDisponivel" x1="9" y1="9" x2="15" y2="15"/>
                </svg>
                <span class="credito-disponivel-valor">
                  {{ creditoDisponivel ? 'Crédito disponível: ' + formatarMoeda(creditoInfo.creditoDisp) : 'Sem crédito disponível' }}
                </span>
                <span *ngIf="creditoInfo.conceito" class="credito-conceito-badge">{{ creditoInfo.conceito }}</span>
              </div>
              <div class="credito-detalhes">
                <span>Limite: <strong>{{ formatarMoeda(creditoInfo.limiteCred) }}</strong></span>
                <span class="credito-sep">|</span>
                <span>À Receber: <strong>{{ formatarMoeda(creditoInfo.pendente) }}</strong></span>
                <span class="credito-sep">|</span>
                <span>Atrasado: <strong [class.valor-atrasado]="creditoInfo.atrasado > 0">{{ formatarMoeda(creditoInfo.atrasado) }}</strong></span>
              </div>
            </div>

            <!-- Label + títulos extras (CNPJ/CPF, COM, INSC. ESTADUAL) — abaixo do banner -->
            <div class="cliente-titulos-linha">
              <label class="form-label required">Cliente</label>
              <span
                *ngFor="let t of titulosClientePosicionados"
                class="cliente-titulo-extra"
                [style.left.px]="t.left"
              >{{ t.label }}</span>
            </div>

            <div class="input-icon-wrap">
              <button type="button" class="cliente-icon-btn" (click)="abrirBuscaCliente()" title="Buscar Cliente">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
              </button>
              <input
                type="text"
                class="form-input"
                style="text-transform: uppercase"
                [style.padding-left.px]="clienteInputStartX - 1.5"
                placeholder="Digite o nome ou CNPJ/CPF..."
                [(ngModel)]="clienteBusca"
                (input)="onClienteInput()"
                (focus)="onClienteFocus()"
                (blur)="onClienteBlur()"
                autocomplete="off"
              >
              <button *ngIf="clienteSelecionado" class="input-clear-btn" type="button" (click)="removerCliente()">✕</button>
              <div class="gpl-copiar-wrap" *ngIf="clienteSelecionado && gplItensCopiaveis('cliente').length > 0">
                <button class="gpl-copiar-btn" type="button" title="Copiar dados" (click)="gplAbrirMenuCopiar('cliente', $event)">⋮</button>
                <div class="gpl-copiar-menu" *ngIf="gplCopiarMenuTipo === 'cliente'">
                  <button *ngFor="let item of gplItensCopiaveis('cliente')" type="button" class="gpl-copiar-item" (click)="gplCopiarCampo(item.valor, item.label)">
                    Copiar {{ item.label }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Dropdown sugestões -->
            <div class="cliente-dropdown" *ngIf="mostrarDropdownCliente">
              <div *ngIf="clienteCarregando" class="cliente-dropdown-loading">
                <app-loading-indicator size="inline"></app-loading-indicator> Buscando...
              </div>
              <div *ngIf="!clienteCarregando && clienteSugestoes.length === 0" class="cliente-dropdown-vazio">
                Nenhum cliente encontrado
              </div>
              <button
                *ngFor="let c of clienteSugestoes"
                type="button"
                class="cliente-dropdown-item"
                (click)="selecionarCliente(c)"
              >
                <div class="cliente-item-nome">{{ c.nomeparc }}</div>
                <div class="cliente-item-detalhes">
                  <span *ngIf="c.docparc">{{ fmtDocumento(c.docparc) }}</span>
                  <span *ngIf="c.adCom">{{ c.adCom }}</span>
                  <span *ngIf="c.inscEstadual">{{ fmtIE(c.inscEstadual) }}</span>
                  <span *ngIf="c.cidade || c.uf" class="cliente-item-cidade">{{ c.cidade }}<ng-container *ngIf="c.cidade && c.uf"> / </ng-container>{{ c.uf }}</span>
                  <span *ngIf="c.codparc" style="color:#999">Código: {{ c.codparc }}</span>
                </div>
              </button>
            </div>

          </div>

          <!-- LINHA 1, COL 1.5: Aeronave -->
          <div class="cliente-autocomplete cab-aero-row1" style="position: relative;">
            <label class="form-label">Aeronave</label>
            <div class="input-icon-wrap">
              <button type="button" class="cliente-icon-btn" (click)="abrirBuscaAeronave()" title="Buscar Aeronave">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.2-1.1.6L3 8l6 4-4 4-2.5-.5L2 16l3.5 2 2 3.5.5-1.5-.5-2.5 4-4 4 6c.4.2.7-.2.6-.7Z"/>
                </svg>
              </button>
              <input type="text" class="form-input" placeholder="Prefixo..."
                [(ngModel)]="aeronaveBusca"
                (input)="onAeronaveInput()"
                (focus)="onAeronaveFocus()"
                (blur)="onAeronaveBlur()"
                autocomplete="off">
              <button *ngIf="aeronaveSelecionada" class="input-clear-btn" type="button" (click)="removerAeronave()">✕</button>
            </div>

            <div *ngIf="aeronaveNaoVinculadaAoCliente" class="aviso-aeronave-desvinculada"
                 style="color:#b45309;font-size:12px;margin-top:4px;line-height:1.3;">
              ⚠ Esta aeronave não está vinculada a este cliente. O Sankhya vai bloquear ao finalizar — troque a aeronave
              ou cadastre-a em "Aeronaves Parceiro" no cadastro do cliente.
            </div>

            <!-- Dropdown sugestões -->
            <div class="cliente-dropdown" *ngIf="mostrarDropdownAeronave" style="width: 250px;">
              <div *ngIf="aeronaveCarregando" class="cliente-dropdown-loading">
                <app-loading-indicator size="inline"></app-loading-indicator> Buscando...
              </div>
              <div *ngIf="!aeronaveCarregando && aeronaveSugestoes.length === 0" class="cliente-dropdown-vazio">
                Nenhuma aeronave encontrada
              </div>
              <button *ngFor="let a of aeronaveSugestoes" type="button" class="cliente-dropdown-item" (click)="selecionarAeronaveAutocomplete(a)">
                <div class="cliente-item-nome">{{ a.prefixo }}</div>
                <div class="cliente-item-detalhes">
                  <span *ngIf="a.nomeProprietario">Propr.: {{ a.nomeProprietario }}</span>
                  <span *ngIf="a.tipoVinculo">{{ a.tipoVinculoDescricao || formatarVinculo(a.tipoVinculo) }}</span>
                  <span style="color:#999">CODAERO: {{ a.codaero }}</span>
                </div>
              </button>
            </div>
          </div>

          <!-- LINHA 1, COL 2: Prioridade (Separação) -->
          <div class="campo-mini cab-col2-row1">
            <label class="form-label">Prioridade (Separação)</label>
            <select class="form-input" [(ngModel)]="prioridade">
              <option *ngFor="let p of prioridadeOpcoes" [value]="p.valor">{{ p.opcao }}</option>
            </select>
          </div>

          <!-- LINHA 1, COL 3: Despachar -->
          <div class="campo-mini cab-col3-row1">
            <label class="form-label">Despachar</label>
            <select class="form-input" [(ngModel)]="despachar">
              <option *ngFor="let o of despacharOpcoes" [value]="o.valor">{{ corrigirTextoOpcao(o) }}</option>
            </select>
          </div>

          <!-- ENDEREÇO DE FATURAMENTO — linha 2, span completo -->
          <div *ngIf="clienteSelecionado && !enderecoCarregando && mostrarEnderecos"
               class="cab-fat-end-row fat-end-container">
            <span class="fat-end-titulo">ENDEREÇO DE FATURAMENTO</span>
            <div class="fat-end-body">
              <div class="form-group fat-end-logradouro">
                <label class="form-label">Logradouro</label>
                <!-- Wrapper: exibe o rótulo simples (sem IE) após seleção; IE aparece só na lista dropdown -->
                <div *ngIf="enderecosDisponiveis.length > 0" class="logradouro-select-wrap">
                  <span class="logradouro-select-display">
                    {{ rotuloLogradouroSimples(codparcFaturamentoSelecionado, enderecosDisponiveis) || 'Selecione...' }}
                  </span>
                  <select class="logradouro-select-overlay"
                    [(ngModel)]="codparcFaturamentoSelecionado"
                    (ngModelChange)="onSelecionarEnderecoFaturamento()"
                    [disabled]="enderecosDisponiveis.length <= 1">
                    <option *ngFor="let e of enderecosDisponiveis" [value]="e.codparc">{{ rotuloLogradouro(e) }}</option>
                  </select>
                </div>
                <input *ngIf="enderecosDisponiveis.length === 0" type="text" class="form-input" [(ngModel)]="endFaturamento.logradouro" disabled>
              </div>
              <div class="form-group fat-end-numero">
                <label class="form-label">Nº</label>
                <input type="text" class="form-input" [(ngModel)]="endFaturamento.numero" disabled>
              </div>
              <div class="form-group fat-end-bairro">
                <label class="form-label">Bairro</label>
                <input type="text" class="form-input" [(ngModel)]="endFaturamento.bairro" disabled>
              </div>
              <div class="form-group fat-end-cidade">
                <label class="form-label">Cidade</label>
                <input type="text" class="form-input" [(ngModel)]="endFaturamento.cidade" disabled>
              </div>
              <div class="form-group fat-end-uf">
                <label class="form-label">UF</label>
                <input type="text" class="form-input" [(ngModel)]="endFaturamento.uf" disabled>
              </div>
              <div class="form-group fat-end-cep">
                <label class="form-label">CEP</label>
                <input type="text" class="form-input" [(ngModel)]="endFaturamento.cep" disabled>
              </div>
              <div class="form-group fat-end-complemento">
                <label class="form-label">Complemento</label>
                <input type="text" class="form-input" [(ngModel)]="endFaturamento.complemento" disabled>
              </div>
            </div>
          </div>

          <!-- LINHA 3, COL 1: Fat. Imediato + Tipo + Tipo de Operação agrupados em flex -->
          <div class="cab-col1-row2">

            <!-- FATURAMENTO IMEDIATO (TGFCAB.GPL_FATIMEDIATO) -->
            <div class="campo-mini">
              <label class="form-label">Fat. Imediato</label>
              <select class="form-input" [(ngModel)]="fatImediato">
                <option *ngFor="let o of fatImediatoOpcoes" [value]="o.valor">{{ corrigirTextoOpcao(o) }}</option>
              </select>
            </div>

            <!-- TIPO (TGFCAB.GPL_TIPO) -->
            <div class="campo-mini">
              <label class="form-label">Tipo</label>
              <select class="form-input" [(ngModel)]="tipoGpl">
                <option *ngFor="let o of tipoGplOpcoes" [value]="o.valor">{{ corrigirTextoOpcao(o) }}</option>
              </select>
            </div>

            <!-- CATEGORIA (TGFCAB.AD_CATEGORIA) — Receita ou Transferência.
                 Transferência troca automaticamente o Tipo de Operação para a
                 TOP 1152 (ver onAdCategoriaChange). -->
            <div class="campo-mini">
              <label class="form-label">Categoria</label>
              <select class="form-input" [(ngModel)]="adCategoria" (ngModelChange)="onAdCategoriaChange()"
                      title="Transferência troca automaticamente o Tipo de Operação para a TOP 1152">
                <option *ngFor="let o of adCategoriaOpcoes" [value]="o.valor">{{ o.opcao }}</option>
              </select>
            </div>

            <!-- STATUS (TGFCAB.GPL_STATUS) — somente leitura, gerenciado pelo sistema -->
            <div class="campo-mini">
              <label class="form-label">Status</label>
              <select class="form-input form-input--readonly" [(ngModel)]="gplStatus" disabled>
                <option *ngFor="let o of gplStatusOpcoes" [value]="o.valor">{{ corrigirTextoOpcao(o) }}</option>
                <option *ngIf="gplStatusOpcoes.length === 0" value="Aberto">Aberto</option>
                <!-- Fallback: se o valor atual não estiver cadastrado no domínio GPL_STATUS do
                     Sankhya (ex.: CANCELADO ainda não configurado lá), mostra mesmo assim. -->
                <option *ngIf="gplStatusNaoListado()"
                  [value]="gplStatus">{{ gplStatus }}</option>
              </select>
            </div>

            <!-- TIPO DE OPERAÇÃO -->
            <div class="campo-tipo-operacao">
              <label class="form-label required">Tipo de Operação</label>
              <select class="form-input" [(ngModel)]="tipoOperacao" disabled
                      title="Tipo de Operação não pode ser editado">
                <option value="">Selecione...</option>
                <option *ngFor="let t of tiposOperacao" [value]="t.codigo">
                  {{ t.codigo }} – {{ t.descricao }}
                </option>
              </select>
            </div>

          </div>

          <!-- LINHA 2, COL 2: Data de Emissão -->
          <div class="form-subgroup cab-col2-row2">
            <label class="form-label required">Data de Emissão</label>
            <input type="date" class="form-input" [(ngModel)]="dataEmissao" disabled>
          </div>

          <!-- LINHA 2, COL 3: Data de Negociação -->
          <div class="form-subgroup cab-col3-row2">
            <label class="form-label required">Data de Negociação</label>
            <input type="date" class="form-input" [(ngModel)]="dtNegociacao" [max]="hojeIso"
                   (change)="onChangeDtNegociacao()">
          </div>

        </div>

        <!-- VENDEDOR + TIPO NEGOCIAÇÃO + COTAÇÃO + AERONAVE (mesma linha) -->
        <div class="form-group span-2 vendedor-cotacao-linha">

          <!-- VENDEDOR -->
          <div class="form-subgroup">
            <label class="form-label required">Vendedor</label>
            <div class="busca-combo">
              <button type="button" class="btn-busca" (click)="abrirBuscaVendedor()" title="Buscar Vendedor">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="7"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button>
              <input type="text" class="busca-combo-input"
                     [value]="valorExibidoVendedor(codVendLogado)"
                     [title]="valorExibidoVendedor(codVendLogado)"
                     (focus)="onFocusVendedor($event)"
                     (input)="onInputVendedor($event)"
                     (blur)="onBlurVendedor($event)"
                     placeholder="Código do vendedor...">
              <button type="button" class="busca-combo-clear" *ngIf="codVendLogado" (click)="limparVendedor()" title="Limpar">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
          </div>

          <!-- % COMISSÃO (TGFCAB.GPL_COMISSAO) -->
          <div class="form-subgroup campo-comissao">
            <label class="form-label">% Comissão</label>
            <input type="text" appMoneyMask [appMoneyMaskMax]="100" class="form-input" [(ngModel)]="gplComissao"
                   [disabled]="!podeEditarComissao"
                   [title]="!podeEditarComissao ? 'Sem permissão para editar % Comissão (PERCOM)' : ''"
                   (blur)="onBlurGplComissao()" placeholder="0,00">
          </div>

          <!-- TIPO NEGOCIAÇÃO / CONDIÇÃO DE PAGAMENTO (TGFTPV) -->
          <div class="form-subgroup">
            <label class="form-label required">Tipo Negociação (Condição de Pagamento)</label>
            <div class="busca-combo">
              <button type="button" class="btn-busca" (click)="abrirBuscaTipoNegociacao()" title="Buscar Condição de Pagamento">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="7"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button>
              <input type="text" class="busca-combo-input"
                     [value]="valorExibidoTipoNegociacao(tipoNegociacaoSelecionado)"
                     [title]="valorExibidoTipoNegociacao(tipoNegociacaoSelecionado)"
                     (focus)="onFocusTipoNegociacao($event)"
                     (input)="onInputTipoNegociacao($event)"
                     (blur)="onBlurTipoNegociacao($event)"
                     placeholder="Código da condição de pagamento...">
              <button type="button" class="busca-combo-clear" *ngIf="tipoNegociacaoSelecionado" (click)="limparTipoNegociacao()" title="Limpar">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
          </div>

          <!-- COTAÇÃO / MOEDA (TSICOT, igual ao Demonstrativo de Vendas) -->
          <div class="form-subgroup">
            <label class="form-label">Cotação (US$)</label>
            <div class="busca-combo">
              <button type="button" class="btn-busca" (click)="abrirBuscaCotacao()" title="Buscar Cotação" [disabled]="!cotacaoEditavel">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="7"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button>
              <input type="text" class="busca-combo-input" [(ngModel)]="cotacaoTexto" placeholder="Buscar cotação..." readonly [disabled]="!cotacaoEditavel">
              <!-- Botão de Limpar removido — não pode existir venda/orçamento sem
                   cotação, então não faz sentido oferecer zerar esse campo (ver
                   também validação em salvar(), que bloqueia gravar sem cotação). -->
              <button type="button" class="busca-combo-clear" (click)="solicitarAtualizarCotacao()" title="Atualizar para a cotação mais recente" [disabled]="!cotacaoEditavel">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="23 4 23 10 17 10"></polyline>
                  <polyline points="1 20 1 14 7 14"></polyline>
                  <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"></path>
                </svg>
              </button>
            </div>
          </div>

        </div>

        <!-- NRO. PED. COMPRA (CLIENTE) + CENTRO RESULTADO + NATUREZA (mesma linha) -->
        <div class="form-group span-2 vendedor-cotacao-linha">

          <!-- NRO. PED. COMPRA / CLIENTE (TGFCAB.NUMPEDIDO2) -->
          <div class="form-subgroup">
            <label class="form-label">Nº Ordem de Compra (Cliente)</label>
            <input type="text" class="form-input" [(ngModel)]="numPedido2" placeholder="Número do pedido de compra do cliente">
          </div>

          <!-- CENTRO RESULTADO (TGFCEN — TGFCAB.CODCENCUS) -->
          <div class="form-subgroup">
            <label class="form-label">Centro Resultado</label>
            <div class="busca-combo">
              <button type="button" class="btn-busca" disabled title="Centro Resultado não pode ser editado">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="7"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button>
              <input type="text" class="busca-combo-input"
                     [value]="valorExibidoCentroResultado(centroResultadoSelecionado)"
                     title="Centro Resultado não pode ser editado"
                     disabled
                     placeholder="Código do centro de resultado...">
            </div>
          </div>

          <!-- NATUREZA (TGFNAT — TGFCAB.CODNAT) -->
          <div class="form-subgroup">
            <label class="form-label">Natureza</label>
            <div class="busca-combo">
              <button type="button" class="btn-busca" disabled title="Natureza não pode ser editada">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="7"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button>
              <input type="text" class="busca-combo-input"
                     [value]="valorExibidoNatureza(naturezaSelecionada)"
                     title="Natureza não pode ser editada"
                     disabled
                     placeholder="Código da natureza...">
            </div>
          </div>

          <!-- Nº TÍTULO (TGFCAB.AD_NUMTITULO) — somente leitura, gerado automaticamente ao gravar -->
          <div class="form-subgroup">
            <label class="form-label">Nº Título</label>
            <input type="text" class="form-input form-input--readonly" [value]="numTitulo || ''" disabled
                   title="Gerado automaticamente ao gravar — não pode ser editado" placeholder="Gerado ao gravar">
          </div>

        </div>

        <!-- Observação Venda/Nota/Interna: no modal "Editar Dados da Venda"
             (somenteCabecalho) fica em uma aba própria (Observações); na tela
             normal continua aqui dentro de Dados do Pedido. -->
        <ng-container *ngIf="!somenteCabecalho">
          <ng-container *ngTemplateOutlet="observacoesTpl"></ng-container>
        </ng-container>

      </div>
    </div>

    <!-- ── ABA OBSERVAÇÕES (somente no modal "Editar Dados da Venda") ── -->
    <div *ngIf="somenteCabecalho && abaPrincipalAtiva === 'observacoes'" class="card">
      <div class="form-grid">
        <ng-container *ngTemplateOutlet="observacoesTpl"></ng-container>
      </div>
    </div>

    <ng-template #observacoesTpl>
      <!-- OBSERVAÇÃO VENDA (TGFCAB.AD_OBS) — fica acima das demais observações -->
      <div class="form-group span-2">
        <label class="form-label">Observação Venda</label>
        <textarea class="form-input form-textarea" [(ngModel)]="adObs" placeholder="Observação da venda..." rows="3"></textarea>
      </div>

      <!-- OBSERVAÇÃO (NOTA) + OBSERVAÇÃO INTERNA (mesma linha) -->
      <div class="form-group span-2 observacao-linha">

        <!-- OBSERVAÇÃO NOTA (TGFCAB.OBSERVACAO) — o usuário só edita o texto
             livre; a linha de Prefixo/Cert.(COM)/Ordem de Compra é gerada
             automaticamente e fica travada, exibida abaixo do campo. -->
        <div class="form-subgroup">
          <label class="form-label">Observação Nota</label>
          <textarea class="form-input form-textarea" [(ngModel)]="observacaoNotaLivre" placeholder="Observações do pedido..." rows="3"></textarea>
          <div class="form-input form-input--readonly observacao-auto-travada" *ngIf="linhaObservacaoAutomatica"
               title="Gerado automaticamente pelo sistema — não editável">
            {{ linhaObservacaoAutomatica }}
          </div>
        </div>

        <!-- OBSERVAÇÃO INTERNA (TGFCAB.AD_OBSINT) -->
        <div class="form-subgroup">
          <label class="form-label">Observação Interna</label>
          <textarea class="form-input form-textarea" [(ngModel)]="observacaoInterna" placeholder="Observações internas (não impressas)..." rows="3"></textarea>
        </div>

      </div>
    </ng-template>

    <!-- ── CARD ENDEREÇOS ── -->
    <ng-container *ngIf="abaPrincipalAtiva === 'enderecos'">

      <!-- Sem cliente selecionado -->
      <div *ngIf="!clienteSelecionado && !enderecoCarregando && !mostrarEnderecos" class="card pv-aba-vazia">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
        </svg>
        <span>Selecione um cliente para ver os endereços</span>
      </div>

      <!-- Loading endereço -->
      <div *ngIf="enderecoCarregando" class="card end-loading">
        <app-loading-indicator size="inline"></app-loading-indicator>
        <span>Carregando endereços do cliente...</span>
      </div>

      <div *ngIf="mostrarEnderecos && !enderecoCarregando" class="card">
        <div class="card-title">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>
            <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
          </svg>
          Entrega
          <ng-container *ngIf="clienteSelecionado">
            <div class="ctc-campos">
              <div class="ctc-campo">
                <span class="ctc-label">Cliente</span>
                <span class="ctc-valor">{{ clienteSelecionado.nomeparc }}</span>
              </div>
              <div class="ctc-campo" *ngIf="clienteSelecionado.docparc">
                <span class="ctc-label">CNPJ/CPF</span>
                <span class="ctc-valor">{{ fmtDocumento(clienteSelecionado.docparc) }}</span>
              </div>
              <div class="ctc-campo" *ngIf="clienteSelecionado.inscEstadual">
                <span class="ctc-label">Insc. Estadual</span>
                <span class="ctc-valor">{{ fmtIE(clienteSelecionado.inscEstadual) }}</span>
              </div>
              <div class="ctc-campo" *ngIf="clienteSelecionado.cidade || clienteSelecionado.uf">
                <span class="ctc-label">Cidade / UF</span>
                <span class="ctc-valor">{{ clienteSelecionado.cidade }}<ng-container *ngIf="clienteSelecionado.cidade && clienteSelecionado.uf"> - </ng-container>{{ clienteSelecionado.uf }}</span>
              </div>
            </div>
            <div class="ctc-aeronave" *ngIf="aeronaveAtualPrefixo">
              <span class="ctc-label">Aeronave</span>
              <span class="ctc-valor ctc-aeronave-prefixo">{{ aeronaveAtualPrefixo }}</span>
            </div>
          </ng-container>
        </div>

        <!-- ── Pessoa de Entrega ── -->
        <div class="pessoa-entrega-wrap">
          <div class="form-group">
            <div class="cliente-titulos-linha">
              <label class="form-label">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                </svg>
                Pessoa de Entrega
              </label>
              <span
                *ngFor="let t of titulosPessoaEntregaPosicionados"
                class="cliente-titulo-extra"
                [style.left.px]="t.left"
              >{{ t.label }}</span>
            </div>
            <div class="input-icon-wrap">
              <button type="button" class="cliente-icon-btn" (click)="onPessoaEntregaFocus()" title="Buscar Pessoa de Entrega">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
              </button>
              <input
                type="text"
                class="form-input"
                style="text-transform: uppercase"
                [style.padding-left.px]="pessoaEntregaInputStartX - 1.5"
                placeholder="Digite o nome ou CNPJ/CPF da pessoa de entrega..."
                [(ngModel)]="pessoaEntregaBusca"
                (input)="onPessoaEntregaInput()"
                (focus)="onPessoaEntregaFocus()"
                (blur)="onPessoaEntregaBlur()"
                autocomplete="off"
              >
              <button *ngIf="pessoaEntregaSelecionada" class="input-clear-btn" type="button" (click)="removerPessoaEntrega()">✕</button>
              <div class="gpl-copiar-wrap" *ngIf="pessoaEntregaSelecionada && gplItensCopiaveis('pessoaEntrega').length > 0">
                <button class="gpl-copiar-btn" type="button" title="Copiar dados" (click)="gplAbrirMenuCopiar('pessoaEntrega', $event)">⋮</button>
                <div class="gpl-copiar-menu" *ngIf="gplCopiarMenuTipo === 'pessoaEntrega'">
                  <button *ngFor="let item of gplItensCopiaveis('pessoaEntrega')" type="button" class="gpl-copiar-item" (click)="gplCopiarCampo(item.valor, item.label)">
                    Copiar {{ item.label }}
                  </button>
                </div>
              </div>
            </div>
            <div class="cliente-dropdown" *ngIf="mostrarDropdownPessoaEntrega">
              <div *ngIf="pessoaEntregaCarregando" class="cliente-dropdown-loading">
                <app-loading-indicator size="inline"></app-loading-indicator> Buscando...
              </div>
              <div *ngIf="!pessoaEntregaCarregando && pessoaEntregaSugestoes.length === 0" class="cliente-dropdown-vazio">
                Nenhuma pessoa encontrada
              </div>
              <button *ngFor="let p of pessoaEntregaSugestoes" type="button"
                class="cliente-dropdown-item" (mousedown)="selecionarPessoaEntrega(p)">
                <div class="cliente-item-nome">{{ p.nomeparc }}</div>
                <div class="cliente-item-detalhes">
                  <span *ngIf="p.docparc">{{ fmtDocumento(p.docparc) }}</span>
                  <span *ngIf="p.inscEstadual">IE: {{ fmtIE(p.inscEstadual) }}</span>
                  <span *ngIf="p.cidade || p.uf" class="cliente-item-cidade">{{ p.cidade }}<ng-container *ngIf="p.cidade && p.uf"> / </ng-container>{{ p.uf }}</span>
                  <span *ngIf="p.codparc" style="color:#999">Código: {{ p.codparc }}</span>
                </div>
              </button>
            </div>
          </div>
        </div>

        <div class="end-entrega-painel">

          <!-- coluna 1: endereço de entrega -->
          <div class="end-entrega-col">
            <div class="end-entrega-col-header">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
              </svg>
              Endereço de Entrega
              <button type="button" class="btn-copiar-end" (click)="copiarFaturamentoParaEntrega()"
                title="Copiar endereço de faturamento para entrega">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                </svg>
                Copiar Fat.
              </button>
            </div>
            <div class="end-form">
              <div class="form-group end-logradouro">
                <label class="form-label">Logradouro</label>
                <!-- Wrapper: exibe o rótulo simples (sem IE) após seleção; IE aparece só na lista dropdown -->
                <div *ngIf="enderecosEntregaDisponiveis.length > 0" class="logradouro-select-wrap">
                  <span class="logradouro-select-display">
                    {{ rotuloLogradouroSimples(codparcEntregaSelecionado, enderecosEntregaDisponiveis) || 'Selecione...' }}
                  </span>
                  <select class="logradouro-select-overlay"
                    [(ngModel)]="codparcEntregaSelecionado"
                    (ngModelChange)="onSelecionarEnderecoEntrega()"
                    [disabled]="enderecosEntregaDisponiveis.length <= 1">
                    <option *ngFor="let e of enderecosEntregaDisponiveis" [value]="e.codparc">{{ rotuloLogradouro(e) }}</option>
                  </select>
                </div>
                <input *ngIf="enderecosEntregaDisponiveis.length === 0" type="text" class="form-input" [(ngModel)]="endEntrega.logradouro" disabled>
              </div>
              <div class="form-group end-numero">
                <label class="form-label">Número</label>
                <input type="text" class="form-input" [(ngModel)]="endEntrega.numero" placeholder="Nº" [disabled]="true">
              </div>
              <div class="form-group end-complemento">
                <label class="form-label">Complemento</label>
                <input type="text" class="form-input" [(ngModel)]="endEntrega.complemento" placeholder="Apto, Sala..." [disabled]="true">
              </div>
              <div class="form-group end-bairro">
                <label class="form-label">Bairro</label>
                <input type="text" class="form-input" [(ngModel)]="endEntrega.bairro" placeholder="Bairro" [disabled]="true">
              </div>
              <div class="form-group end-cep">
                <label class="form-label">CEP</label>
                <input type="text" class="form-input" [(ngModel)]="endEntrega.cep" placeholder="00000-000" [disabled]="true">
              </div>
              <div class="form-group end-cidade">
                <label class="form-label">Cidade</label>
                <input type="text" class="form-input" [(ngModel)]="endEntrega.cidade" placeholder="Cidade" [disabled]="true">
              </div>
              <div class="form-group end-uf">
                <label class="form-label">UF</label>
                <input type="text" class="form-input" [(ngModel)]="endEntrega.uf" placeholder="UF" maxlength="2" [disabled]="true">
              </div>
            </div>
          </div>

          <!-- divisor vertical -->
          <div class="end-col-divisor"></div>

          <!-- coluna 2: dados do transporte -->
          <div class="end-entrega-col">
            <div class="end-entrega-col-header">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>
                <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
              </svg>
              Dados do Transporte
            </div>
            <div class="transp-form">
              <div class="form-group transp-codparc-transp">
                <div class="cliente-titulos-linha">
                  <label class="form-label">Transportadora</label>
                  <span
                    *ngFor="let t of titulosTranspPosicionados"
                    class="cliente-titulo-extra"
                    [style.left.px]="t.left"
                  >{{ t.label }}</span>
                </div>
                <div class="input-icon-wrap">
                  <button type="button" class="cliente-icon-btn" (click)="onTranspFocus()" title="Buscar Transportadora">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                    </svg>
                  </button>
                  <input
                    type="text"
                    class="form-input"
                    style="text-transform: uppercase"
                    [style.padding-left.px]="transpInputStartX - 1.5"
                    placeholder="Digite o nome ou CNPJ/CPF..."
                    [(ngModel)]="transpBusca"
                    (input)="onTranspInput()"
                    (focus)="onTranspFocus()"
                    (blur)="onTranspBlur()"
                    autocomplete="off"
                  >
                  <button *ngIf="transpSelecionada" class="input-clear-btn" type="button" (click)="removerTransp()">✕</button>
                  <div class="gpl-copiar-wrap" *ngIf="transpSelecionada && gplItensCopiaveis('transp').length > 0">
                    <button class="gpl-copiar-btn" type="button" title="Copiar dados" (click)="gplAbrirMenuCopiar('transp', $event)">⋮</button>
                    <div class="gpl-copiar-menu" *ngIf="gplCopiarMenuTipo === 'transp'">
                      <button *ngFor="let item of gplItensCopiaveis('transp')" type="button" class="gpl-copiar-item" (click)="gplCopiarCampo(item.valor, item.label)">
                        Copiar {{ item.label }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="cliente-dropdown" *ngIf="mostrarDropdownTransp">
                  <div *ngIf="transpCarregando" class="cliente-dropdown-loading">
                    <app-loading-indicator size="inline"></app-loading-indicator> Buscando...
                  </div>
                  <div *ngIf="!transpCarregando && transpSugestoes.length === 0" class="cliente-dropdown-vazio">
                    Nenhuma transportadora encontrada
                  </div>
                  <button *ngFor="let t of transpSugestoes" type="button"
                    class="cliente-dropdown-item" (mousedown)="selecionarTransp(t)">
                    <div class="cliente-item-nome">{{ t.nomeparc }}</div>
                    <div class="cliente-item-detalhes">
                      <span *ngIf="t.docparc">{{ fmtDocumento(t.docparc) }}</span>
                      <span *ngIf="t.inscEstadual">{{ fmtIE(t.inscEstadual) }}</span>
                      <span *ngIf="t.codparc" style="color:#999">Código: {{ t.codparc }}</span>
                    </div>
                  </button>
                </div>
              </div>
              <!-- Linha 2: QTD Vol | Peso Bruto | Tipo Frete -->
              <div class="form-group transp-qtd-vol">
                <label class="form-label">Qtd. Volumes</label>
                <input type="number" class="form-input" [(ngModel)]="qtdVol" min="0" step="1" placeholder="0">
              </div>
              <div class="form-group transp-peso">
                <label class="form-label">Peso Bruto (kg)</label>
                <input type="number" class="form-input" [(ngModel)]="pesoBruto" min="0" step="0.001" placeholder="0,000">
              </div>
              <div class="form-group transp-tip-frete">
                <label class="form-label">Tipo do Frete</label>
                <select class="form-input" [(ngModel)]="tipFrete">
                  <option value="">Selecione</option>
                  <option *ngFor="let o of tipFreteOpcoes" [value]="o.valor"
                      [disabled]="vlrFreteBloqueado && o.opcao.toUpperCase().includes('INCLUS')">{{ o.opcao }}</option>
                </select>
              </div>
              <!-- Linha 3: CIF/FOB | Forma Envio | Vlr Frete | Vlr Frete Total -->
              <div class="form-group transp-cif-fob">
                <label class="form-label">CIF/FOB</label>
                <select class="form-input" [(ngModel)]="cifFob" (ngModelChange)="onCifFobChange()">
                  <option value="">Selecione</option>
                  <option *ngFor="let o of cifFobOpcoes" [value]="o.valor">{{ o.opcao }}</option>
                </select>
              </div>
              <div class="form-group transp-forma-envio">
                <label class="form-label">Forma de Envio</label>
                <select class="form-input" [(ngModel)]="formaEnvio">
                  <option *ngFor="let o of formaEnvioOpcoes" [value]="o.valor">{{ corrigirTextoOpcao(o) }}</option>
                </select>
              </div>
              <div class="form-group transp-vlr-frete">
                <label class="form-label">Vlr. Frete</label>
                <input type="text" appMoneyMask class="form-input" [(ngModel)]="vlrFrete" placeholder="0,00"
                    [disabled]="vlrFreteBloqueado"
                    [title]="vlrFreteBloqueado ? 'Modalidade de frete selecionada não permite cobrar frete nesta nota' : ''">
              </div>
              <div class="form-group transp-vlr-frete-total" *ngIf="false">
                <label class="form-label">Vlr. Frete Total</label>
                <input type="number" class="form-input" [ngModel]="vlrFreteTotalTransporte" min="0" step="0.01" placeholder="0,00" disabled>
              </div>
            </div>
            <!-- OBSERVAÇÃO FRETE (TGFCAB.AD_FRETEOBS) -->
            <div class="form-group">
              <label class="form-label">Observação Frete</label>
              <textarea class="form-input form-textarea" [(ngModel)]="adFreteObs" placeholder="Observação sobre o frete..." rows="3"></textarea>
            </div>
          </div>

        </div>

      </div>
    </ng-container>

    </fieldset>
    <!-- ── CARD ITENS — SÓ DESCONTO (modal "Editar Dados da Venda") ──
         Versão enxuta da Grade de Itens: mostra PN/Descrição/Qtd/Preço só
         pra referência (somente leitura) e libera editar Desc/Acrs % e
         Desc/Acrs Vlr por item — reaproveita os mesmos campos/handlers
         (item.desconto, item.vlrDescStr, onDescontoPercChange,
         onDescontoVlrChange) da Grade de Itens completa, então o cálculo e
         a gravação já funcionam sem duplicar lógica. Pedido de status PRONTO
         (e outros liberados pra "Editar Dados da Venda") pode ajustar
         desconto por aqui sem abrir o pedido inteiro. IMPORTANTE: este card
         fica FORA do <fieldset [disabled]="modoSomenteLeitura"> de propósito —
         um <fieldset disabled> desabilita TODOS os controles descendentes
         independente do [disabled] individual de cada input, então pra editar
         desconto com status bloqueado (PRONTO/LOGISTICA/etc.) o card precisa
         estar fora dele. Os demais cards (dados/endereços/itens completos/
         comissões) continuam protegidos por um segundo <fieldset> logo abaixo. -->
    <div *ngIf="somenteCabecalho && abaPrincipalAtiva === 'itensDesconto'" class="card">
      <div class="card-title">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/>
          <line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/>
          <line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
        </svg>
        Desconto dos Itens
        <span class="badge-count" *ngIf="itensPreenchiidos > 0">{{ itensPreenchiidos }}</span>
      </div>

      <div class="itens-table-wrap">
        <table class="itens-table">
          <thead>
            <tr>
              <th class="col-pn">PN</th>
              <th class="col-desc">Descrição</th>
              <th class="col-un">UN</th>
              <th class="col-qtd">Qtd</th>
              <th class="col-preco">Vl. Unit. R$</th>
              <th class="col-desc-pct col-desc-red">Desc/Acrs. %</th>
              <th class="col-desc-vlr col-desc-red">Desc/Acrs. Vlr</th>
              <th class="col-total">Subtotal R$</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of itens">
              <td class="td-pn"><span class="cell-desc-text">{{ item.codprod || '—' }}</span></td>
              <td class="td-desc"><span class="cell-desc-text">{{ item.descricao || '—' }}</span></td>
              <td class="td-un"><span class="cell-un-text">{{ item.unidade || 'UN' }}</span></td>
              <td><span class="cell-preco-unit-text">{{ item.quantidade || 0 }}</span></td>
              <td class="td-preco-unit"><span class="cell-preco-unit-text">{{ item.precoUnitario > 0 ? formatarDecimal(item.precoUnitario) : '0,00' }}</span></td>
              <td class="col-desc-red-cell col-desc-pct-cell"
                  [class.cell-desc-desconto]="(item.desconto || 0) > 0"
                  [class.cell-desc-acresc]="(item.desconto || 0) < 0"
                  [class.cell-desc-zero]="(item.desconto || 0) === 0">
                <input type="number" class="cell-input cell-sm cell-desc-input" [(ngModel)]="item.desconto"
                    min="0" max="100" step="0.1" (ngModelChange)="onDescontoPercChange(item)"
                    (focus)="selecionarTextoCampo($event)">
              </td>
              <td class="col-desc-red-cell"
                  [class.cell-desc-desconto]="(item.vlrDesc || 0) > 0"
                  [class.cell-desc-acresc]="(item.vlrDesc || 0) < 0"
                  [class.cell-desc-zero]="(item.vlrDesc || 0) === 0">
                <input type="text" class="cell-input cell-sm cell-desc-input"
                    [(ngModel)]="item.vlrDescStr"
                    (ngModelChange)="onDescontoVlrChange(item)"
                    (blur)="onDescontoVlrBlur(item)"
                    placeholder="0,00">
              </td>
              <td class="col-total-valor">{{ formatarMoeda(item.total) }}</td>
            </tr>
            <tr *ngIf="itens.length === 0">
              <td colspan="8" class="tfoot-vazio" style="text-align:center; padding:16px;">Nenhum item neste pedido.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Painel de Totais / Desconto Geral — mesmos campos e mesma lógica de
           rateio (aplicarRateioDesconto/onDescGeralBlur/onTotalPedidoBlur) já
           usados na aba "Itens do Pedido". Reproduzido aqui porque aquele
           painel vive dentro do <fieldset [disabled]="modoSomenteLeitura">
           logo abaixo, que fica desabilitado quando o STATUS bloqueia edição
           completa — este card fica FORA do fieldset de propósito, então os
           mesmos campos precisam existir aqui pra funcionar independente do
           STATUS. -->
      <div class="itens-rodape-linha">
        <div class="totais-panel">
          <div class="totais-grupo totais-grupo-editavel">
            <div class="totais-linha"
                 [class.totais-desconto]="(percDescGeral || 0) > 0"
                 [class.totais-acresc]="(percDescGeral || 0) < 0">
              <span class="totais-label">% Desc\Acrs. Geral</span>
              <span class="totais-valor total-pedido-wrap">
                <span class="total-pedido-valor">{{ percDescGeral != null ? formatarDecimal(percDescGeral) + ' %' : '0,00 %' }}</span>
                <input type="number" class="total-pedido-input" [(ngModel)]="percDescGeral"
                  step="0.01" placeholder="0,00"
                  title="Clique para editar o percentual de desconto/acréscimo geral (rateia entre os itens)"
                  (ngModelChange)="onDescGeralPercChange()"
                  (keydown)="bloquearSinalDuplicado($event)"
                  (paste)="bloquearColagemSinalDuplicado($event)"
                  (blur)="onDescGeralBlur()">
              </span>
            </div>
            <div class="totais-linha"
                 [class.totais-desconto]="(vlrDescGeral || 0) > 0"
                 [class.totais-acresc]="(vlrDescGeral || 0) < 0">
              <span class="totais-label">Desc\Acrs. Geral U$</span>
              <span class="totais-valor total-pedido-wrap">
                <span class="total-pedido-valor">{{ vlrDescGeralUsd != null ? '$ ' + formatarDecimal(vlrDescGeralUsd) : '$ 0,00' }}</span>
                <input type="number" class="total-pedido-input" [(ngModel)]="vlrDescGeralUsd"
                  step="0.01" placeholder="0,00"
                  title="Clique para editar o desconto/acréscimo geral em U$"
                  (keydown)="bloquearSinalDuplicado($event)"
                  (paste)="bloquearColagemSinalDuplicado($event)"
                  (blur)="onDescGeralBlur()">
              </span>
            </div>
            <div class="totais-linha"
                 [class.totais-desconto]="(vlrDescGeral || 0) > 0"
                 [class.totais-acresc]="(vlrDescGeral || 0) < 0">
              <span class="totais-label">Desc\Acrs. Geral R$</span>
              <span class="totais-valor total-pedido-wrap">
                <span class="total-pedido-valor">{{ vlrDescGeral != null ? formatarMoeda(vlrDescGeral) : formatarMoeda(0) }}</span>
                <input type="number" class="total-pedido-input" [(ngModel)]="vlrDescGeral"
                  step="0.01" placeholder="0,00"
                  title="Clique para editar o desconto/acréscimo geral em R$ (rateia entre os itens)"
                  (ngModelChange)="onDescGeralVlrChange()"
                  (keydown)="bloquearSinalDuplicado($event)"
                  (paste)="bloquearColagemSinalDuplicado($event)"
                  (blur)="onDescGeralBlur()">
              </span>
            </div>
          </div>

          <div class="totais-sep totais-sep-final"></div>
          <div class="totais-grupo totais-grupo-final">
            <div class="totais-linha totais-final">
              <span class="totais-label">Total do Pedido R$</span>
              <span class="totais-valor total-pedido-wrap">
                <span class="total-pedido-valor">{{ formatarMoeda(totalPedido) }}</span>
                <input type="text" class="total-pedido-input"
                  [(ngModel)]="totalPedidoDesejadoStr"
                  (focus)="onTotalPedidoFocus()"
                  (blur)="onTotalPedidoBlur()"
                  (keydown.enter)="onTotalPedidoEnter($event)"
                  [placeholder]="formatarMoeda(totalPedido)"
                  title="Digite o total desejado para ratear o desconto entre os itens">
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <fieldset [disabled]="modoSomenteLeitura" style="border:none; padding:0; margin:0; min-width: 0;">
    <!-- ── CARD ITENS ── -->
    <div *ngIf="abaPrincipalAtiva === 'itens'" class="card">
      <div class="card-title">
        <!-- input oculto de seleção de arquivo Excel -->
        <input id="excel-import-input" type="file" accept=".xlsx,.xls" style="display:none"
          (change)="onExcelSelecionado($event)">
        <!-- botão ícone Excel — antes do título -->
        <button type="button" class="btn-importar-excel-icon" (click)="abrirSeletorExcel()" title="Importar itens de planilha Excel (Padrão de Colunas Obrigatórias: PN e Quantidade)">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="12" y1="12" x2="12" y2="18"/>
            <line x1="9" y1="15" x2="12" y2="12"/>
            <line x1="15" y1="15" x2="12" y2="12"/>
          </svg>
        </button>
        <!-- botão ícone Exportar Itens — ao lado do Importar -->
        <button type="button" class="btn-importar-excel-icon btn-exportar-excel-icon" (click)="exportarItensExcel()" title="Exportar itens da venda para planilha Excel">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="12" y1="18" x2="12" y2="12"/>
            <line x1="9" y1="15" x2="12" y2="18"/>
            <line x1="15" y1="15" x2="12" y2="18"/>
          </svg>
        </button>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/>
          <line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/>
          <line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
        </svg>
        Itens do Pedido
        <span class="badge-count" *ngIf="itensPreenchiidos > 0">{{ itensPreenchiidos }}</span>
        <ng-container *ngIf="clienteSelecionado">
          <div class="ctc-campos">
            <div class="ctc-campo">
              <span class="ctc-label">Cliente</span>
              <span class="ctc-valor">{{ clienteSelecionado.nomeparc }}</span>
            </div>
            <div class="ctc-campo" *ngIf="clienteSelecionado.docparc">
              <span class="ctc-label">CNPJ/CPF</span>
              <span class="ctc-valor">{{ fmtDocumento(clienteSelecionado.docparc) }}</span>
            </div>
            <div class="ctc-campo" *ngIf="clienteSelecionado.inscEstadual">
              <span class="ctc-label">Insc. Estadual</span>
              <span class="ctc-valor">{{ fmtIE(clienteSelecionado.inscEstadual) }}</span>
            </div>
            <div class="ctc-campo" *ngIf="clienteSelecionado.cidade || clienteSelecionado.uf">
              <span class="ctc-label">Cidade / UF</span>
              <span class="ctc-valor">{{ clienteSelecionado.cidade }}<ng-container *ngIf="clienteSelecionado.cidade && clienteSelecionado.uf"> - </ng-container>{{ clienteSelecionado.uf }}</span>
            </div>
          </div>
          <div class="ctc-aeronave" *ngIf="aeronaveAtualPrefixo">
            <span class="ctc-label">Aeronave</span>
            <span class="ctc-valor ctc-aeronave-prefixo">{{ aeronaveAtualPrefixo }}</span>
          </div>
        </ng-container>
      </div>



      <div class="itens-table-wrap">
        <table class="itens-table">
          <thead>
            <tr>
              <th class="col-ord">ORD</th>
              <th class="col-pn">PN</th>
              <th class="col-desc">Descrição</th>
              <th class="col-un">UN</th>
              <th class="col-qtd">Qtd</th>
              <th class="col-preco-usd">Vl. Unit. U$</th>
              <th class="col-preco">Vl. Unit. R$</th>
              <th class="col-core col-core-destaque-th">CORE</th>
              <th class="col-vlr-core col-core-destaque-th">Core Unit U$</th>
              <th class="col-total-core-usd col-core-destaque-th">Total Core U$</th>
              <th class="col-desc-pct col-desc-red">Desc/Acrs. %</th>
              <th class="col-desc-vlr col-desc-red">Desc/Acrs. Vlr</th>
              <th class="col-total-usd">Subtotal U$</th>
              <th class="col-total">Subtotal R$</th>
              <th class="col-aliq-ipi">Alíq. IPI</th>
              <th class="col-vlr-ipi">Vlr. IPI</th>
              <th class="col-vlr-st">Vlr. ST</th>
              <th class="col-estoque col-disponivel-th">Disponível</th>
              <th class="col-local" title="Local de estoque de onde o item será baixado — clique na linha para trocar">Local</th>
              <th class="col-pf" title="Informativo: GPL_CONTROLADO (S/N) do produto">PF</th>
              <th class="col-cod">Cód. Peça</th>
              <th class="col-acao"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of itens; let i = index"
                [class.item-sem-preco]="item.codprodInterno && precoBaseItem(item) <= 0"
                [class.item-preco-desatualizado]="item.codprodInterno && precoBaseItem(item) > 0 && (item.precoDesatualizado || item.precoDivergenteCatalogo)"
                [class.item-sem-estoque]="item.codprodInterno && precoBaseItem(item) > 0 && !item.precoDesatualizado && !item.precoDivergenteCatalogo && item.estoque <= 0"
                [class.item-controlado-bloqueado]="item.controladoBloqueado">
              <td class="td-ord">{{ i + 1 }}</td>
              <td class="td-pn">
                <input type="text" class="cell-input cell-pn-input" [(ngModel)]="item.codprod"
                  placeholder="PN / F3" [disabled]="!!item.buscando"
                  (keydown.enter)="abrirBuscaPecas(item, $event)"
                  (keydown.f3)="abrirBuscaPecas(item, $event)"
                  (keydown.f2)="onF2Navegar($event)" (keydown.arrowdown)="onF2Navegar($event)" (keydown.arrowup)="onArrowUpNavegar($event)"
                  (blur)="onPnBlur(item, $event)">
                <span *ngIf="item.buscando" class="pn-buscando">…</span>
                <div *ngIf="item.adCondicao" class="condicao-peca">{{ item.adCondicao }}</div>
              </td>
              <td class="td-desc">
                <span class="cell-desc-text">{{ item.descricao || '—' }}</span>
                <!-- Indicador Nacional/Internacional oculto por enquanto (a pedido do usuário) -->
                <span *ngIf="false && item.origem" class="origem-badge">{{ item.origem }}</span>
              </td>
              <td class="td-un">
                <span class="cell-un-text">{{ item.unidade || 'UN' }}</span>
              </td>
              <td>
                <input type="number" class="cell-input cell-qtd-input" [(ngModel)]="item.quantidade"
                    [class.cell-input-erro]="item.controladoBloqueado"
                    [title]="item.controladoBloqueado ? item.controladoMensagem : null"
                    min="0.001" step="0.001" (ngModelChange)="calcularTotal(item)"
                    (blur)="onQtdBlur(item)"
                    (keydown.enter)="confirmarItem(item, $event)"
                    (keydown.f2)="onF2Navegar($event)" (keydown.arrowdown)="onF2Navegar($event)" (keydown.arrowup)="onArrowUpNavegar($event)">
              </td>
              <td>
                <input *ngIf="!item.fabricante70" type="text" class="cell-input cell-md cell-preco-usd-input"
                    [(ngModel)]="item.precoUsdStr"
                    [disabled]="!podeEditarPreco"
                    [title]="!podeEditarPreco ? 'Sem permissão para editar preço (EDTPRE)' : ''"
                    (ngModelChange)="onPrecoUsdChange(item)"
                    (blur)="onPrecoUsdBlur(item)"
                    (keydown.enter)="focarCampoItem($event, item, 'desconto')"
                    (keydown.f2)="onF2Navegar($event)" (keydown.arrowdown)="onF2Navegar($event)" (keydown.arrowup)="onArrowUpNavegar($event)"
                    placeholder="0,00">
                <!-- Fabricante 70: U$ é calculado (Vl. Unit. R$ ÷ cotação) — só leitura aqui. -->
                <span *ngIf="item.fabricante70" class="cell-preco-unit-text" title="Calculado a partir do Vl. Unit. R$ (÷ cotação do dia)">{{ item.precoUsd > 0 ? formatarDecimal(item.precoUsd) : '0,00' }}</span>
              </td>
              <td class="td-preco-unit">
                <span *ngIf="!item.fabricante70" class="cell-preco-unit-text">{{ item.precoUnitario > 0 ? formatarDecimal(item.precoUnitario) : '0,00' }}</span>
                <input *ngIf="item.fabricante70" type="text" class="cell-input cell-md cell-preco-unit-input"
                    [(ngModel)]="item.precoUnitarioStr"
                    [disabled]="!podeEditarPreco"
                    [title]="!podeEditarPreco ? 'Sem permissão para editar preço (EDTPRE)' : ''"
                    (ngModelChange)="onPrecoUnitarioChange(item)"
                    (blur)="onPrecoUnitarioBlur(item)"
                    (keydown.enter)="focarCampoItem($event, item, 'desconto')"
                    (keydown.f2)="onF2Navegar($event)" (keydown.arrowdown)="onF2Navegar($event)" (keydown.arrowup)="onArrowUpNavegar($event)"
                    placeholder="0,00">
              </td>
              <td class="col-core-valor col-core-destaque-cell">
                <span class="badge-core"
                      [class.badge-core-sim]="item.controlaCore"
                      [class.badge-core-nao]="!item.controlaCore && !(item.vlrCore > 0)"
                      [class.badge-core-nao-reativo]="!item.controlaCore && item.vlrCore > 0"
                      [class.badge-core-clicavel]="item.controlaCore || item.vlrCore > 0"
                      [class.badge-core-disabled]="!item.controlaCore && !(item.vlrCore > 0)"
                      [title]="item.controlaCore ? 'Clique para desativar Core' : (item.vlrCore > 0 ? 'Clique para reativar Core' : 'Sem Core cadastrado')"
                      (click)="toggleCore(item)">
                  {{ item.controlaCore ? 'Sim' : 'Não' }}
                </span>
              </td>
              <td class="col-vlr-core-valor col-core-destaque-cell">
                <ng-container *ngIf="item.controlaCore">
                  <span class="core-vlr-display">{{ formatarDecimal(item.vlrCore) }}</span>
                </ng-container>
                <span *ngIf="!item.controlaCore" class="cell-zero">0,00</span>
              </td>
              <td class="col-total-core-valor col-core-destaque-cell">
                <span *ngIf="item.controlaCore && item.totalCoreUsd > 0">{{ formatarDecimal(item.totalCoreUsd) }}</span>
                <span *ngIf="!item.controlaCore || item.totalCoreUsd === 0" class="cell-zero">0,00</span>
              </td>
              <td class="col-desc-red-cell col-desc-pct-cell"
                  [class.cell-desc-desconto]="(item.desconto || 0) > 0"
                  [class.cell-desc-acresc]="(item.desconto || 0) < 0"
                  [class.cell-desc-zero]="(item.desconto || 0) === 0">
                <input type="number" class="cell-input cell-sm cell-desc-input" [(ngModel)]="item.desconto"
                    min="0" max="100" step="0.1" (ngModelChange)="onDescontoPercChange(item)"
                    (focus)="selecionarTextoCampo($event)"
                    (keydown.enter)="focarCampoItem($event, item, 'vlrDesc')"
                    (keydown.f2)="onF2Navegar($event)" (keydown.arrowdown)="onF2Navegar($event)" (keydown.arrowup)="onArrowUpNavegar($event)">
              </td>
              <td class="col-desc-red-cell"
                  [class.cell-desc-desconto]="(item.vlrDesc || 0) > 0"
                  [class.cell-desc-acresc]="(item.vlrDesc || 0) < 0"
                  [class.cell-desc-zero]="(item.vlrDesc || 0) === 0">
                <input type="text" class="cell-input cell-sm cell-desc-input"
                    [(ngModel)]="item.vlrDescStr"
                    (ngModelChange)="onDescontoVlrChange(item)"
                    (blur)="onDescontoVlrBlur(item)"
                    (keydown.enter)="confirmarItem(item, $event)"
                    (keydown.f2)="onF2Navegar($event)" (keydown.arrowdown)="onF2Navegar($event)" (keydown.arrowup)="onArrowUpNavegar($event)"
                    placeholder="0,00">
              </td>
              <td class="col-total-valor col-total-usd-valor">{{ item.totalUsd > 0 ? formatarDecimal(item.totalUsd) : '0,00' }}</td>
              <td class="col-total-valor">
                {{ formatarMoeda(item.total) }}
              </td>
              <!-- 1.2-4: mostra a alíquota com a MESMA precisão do Sankhya nativo
                   (ex.: 0,3250%), em vez de arredondar sempre pra 2 casas
                   (0,33%) — casos com 2 casas exatas (ex.: 5,00%) continuam
                   mostrando só 2. -->
              <td class="col-fiscal-val" style="text-align:center"
                  [class.ncm-hover-target]="item.ncm"
                  [title]="item.ncm ? ('NCM: ' + item.ncm + ' — clique para copiar') : 'NCM não cadastrado no produto'"
                  (click)="item.ncm && gplCopiarCampo(item.ncm, 'NCM', 'NCM copiado com sucesso!')">
                {{ (item.aliqIpi || 0) > 0 ? ((item.aliqIpi || 0) | number:'1.2-4') + '%' : '0,00%' }}
              </td>
              <td class="col-fiscal-val col-fiscal-destaque"
                  [class.ncm-hover-target]="item.ncm"
                  [title]="item.ncm ? ('NCM: ' + item.ncm + ' — clique para copiar') : 'NCM não cadastrado no produto'"
                  (click)="item.ncm && gplCopiarCampo(item.ncm, 'NCM', 'NCM copiado com sucesso!')">
                {{ (item.vlrIpi || 0) > 0 ? formatarMoeda(item.vlrIpi || 0) : '0,00' }}
              </td>
              <td class="col-fiscal-val col-fiscal-destaque"
                  [class.ncm-hover-target]="item.ncm"
                  [title]="item.ncm ? ('NCM: ' + item.ncm + ' — clique para copiar') : 'NCM não cadastrado no produto'"
                  (click)="item.ncm && gplCopiarCampo(item.ncm, 'NCM', 'NCM copiado com sucesso!')">
                {{ (item.vlrIcmsst || 0) > 0 ? formatarMoeda(item.vlrIcmsst || 0) : '0,00' }}
              </td>
              <td class="td-estoque col-disponivel-cell">
                <span [class.estoque-zero]="item.estoque <= 0">
                  {{ item.estoque > 0 ? (fmtQtd(item.estoque, item.unidade)) : (item.codprodInterno ? '0' : '—') }}
                </span>
              </td>
              <td class="td-local local-picker">
                <span *ngIf="item.codprodInterno" class="cell-local-valor"
                    [title]="item.descrLocal || 'Clique para escolher o local de estoque'"
                    (click)="abrirSeletorLocal(item, $event)">
                  {{ item.descrLocal || (item.codlocal ? ('Local ' + item.codlocal) : 'Definir…') }}
                </span>
                <span *ngIf="!item.codprodInterno">—</span>
                <div *ngIf="seletorLocalItemId === item.id" class="local-popover" (click)="$event.stopPropagation()">
                  <div *ngIf="seletorLocalCarregando" class="local-popover-msg"><app-loading-indicator size="inline"></app-loading-indicator> Carregando…</div>
                  <div *ngIf="!seletorLocalCarregando && seletorLocalOpcoes.length === 0" class="local-popover-msg">Nenhum local com estoque encontrado.</div>
                  <ul *ngIf="!seletorLocalCarregando && seletorLocalOpcoes.length > 0" class="local-popover-lista">
                    <li *ngFor="let op of seletorLocalOpcoes"
                        [class.local-opcao-atual]="op.codLocal === item.codlocal"
                        (click)="selecionarLocalItem(item, op)">
                      <span class="local-opcao-nome">{{ op.descrLocal }}</span>
                      <span class="local-opcao-qtd">{{ formatarDecimal(op.disponivel) }}</span>
                    </li>
                  </ul>
                </div>
              </td>
              <td class="td-pf" [title]="'GPL_CONTROLADO: ' + (item.codprodInterno ? (item.controlado ? 'S' : 'N') : '—')">
                <span *ngIf="item.codprodInterno" [class.pf-sim]="item.controlado" [class.pf-nao]="!item.controlado">
                  {{ item.controlado ? 'S' : 'N' }}
                </span>
                <span *ngIf="!item.codprodInterno">—</span>
              </td>
              <td class="td-cod">{{ item.codprodInterno || '—' }}</td>
              <td>
                <button type="button" class="btn-remover-item"
                  (click)="solicitarRemocaoItem(item.id)"
                  [disabled]="!item.codprodInterno && !item.descricao"
                  [title]="(!item.codprodInterno && !item.descricao) ? 'Linha vazia — não pode ser removida' : 'Remover item'">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
                    <path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
          <tfoot class="itens-tfoot">
            <tr>
              <!-- ORD, PN, Descrição, UN, Qtd, Vl.Unit U$, Vl.Unit R$, CORE, Core Unit U$ -->
              <td colspan="9" class="tfoot-vazio"></td>
              <!-- Total Core U$ -->
              <td class="tfoot-total tfoot-core col-core-destaque-cell">
                <span class="tfoot-label">Total Core U$</span>
                <span class="tfoot-valor">{{ totalCoreUsd > 0 ? formatarDecimal(totalCoreUsd) : '0,00' }}</span>
              </td>
              <!-- Desc. %, Desc. Vlr -->
              <td colspan="2" class="tfoot-vazio"></td>
              <!-- Subtotal U$ -->
              <td class="tfoot-total tfoot-subtotal">
                <span class="tfoot-label">Subtotal U$</span>
                <span class="tfoot-valor">{{ subtotalExibicaoUsd > 0 ? formatarDecimal(subtotalExibicaoUsd) : '0,00' }}</span>
              </td>
              <!-- Subtotal R$ -->
              <td class="tfoot-total tfoot-subtotal">
                <span class="tfoot-label">Subtotal R$</span>
                <span class="tfoot-valor">{{ formatarMoeda(subtotalExibicaoBrl) }}</span>
              </td>
              <!-- Alíq. IPI (vazio) -->
              <td class="tfoot-vazio"></td>
              <!-- Total IPI -->
              <td class="tfoot-total tfoot-imposto col-fiscal-destaque">
                <span class="tfoot-label">Total IPI</span>
                <span class="tfoot-valor">{{ totalIpi > 0 ? formatarMoeda(totalIpi) : '0,00' }}</span>
              </td>
              <!-- Total ST -->
              <td class="tfoot-total tfoot-imposto col-fiscal-destaque">
                <span class="tfoot-label">Total ST</span>
                <span class="tfoot-valor">{{ totalIcmsst > 0 ? formatarMoeda(totalIcmsst) : '0,00' }}</span>
              </td>
              <!-- Disponível, Local, PF, Cód. Peça, Ação -->
              <td colspan="5" class="tfoot-vazio"></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- Legenda de cores + Painel de Totais lado a lado -->
      <div class="itens-rodape-linha">

      <!-- Legenda das cores de destaque da tabela -->
      <div class="itens-legenda">
        <span class="legenda-item"><span class="legenda-dot legenda-dot-amarelo"></span>Sem Preço</span>
        <span class="legenda-item"><span class="legenda-dot legenda-dot-vermelho"></span>Preço Desatualizado</span>
        <span class="legenda-item"><span class="legenda-dot legenda-dot-laranja"></span>Estoque Indisponível</span>
      </div>

      <!-- Painel de Totais -->
      <div class="totais-panel">

        <!-- Grupo: Desconto Geral (clique para editar) -->
        <div class="totais-grupo totais-grupo-editavel">
          <div class="totais-linha"
               [class.totais-desconto]="(percDescGeral || 0) > 0"
               [class.totais-acresc]="(percDescGeral || 0) < 0">
            <span class="totais-label">% Desc\Acrs. Geral</span>
            <span class="totais-valor total-pedido-wrap">
              <span class="total-pedido-valor">{{ percDescGeral != null ? formatarDecimal(percDescGeral) + ' %' : '0,00 %' }}</span>
              <input type="number" class="total-pedido-input" [(ngModel)]="percDescGeral"
                step="0.01" placeholder="0,00"
                title="Clique para editar o percentual de desconto/acréscimo geral"
                (ngModelChange)="onDescGeralPercChange()"
                (keydown)="bloquearSinalDuplicado($event)"
                (paste)="bloquearColagemSinalDuplicado($event)"
                (blur)="onDescGeralBlur()">
            </span>
          </div>
          <div class="totais-linha"
               [class.totais-desconto]="(vlrDescGeral || 0) > 0"
               [class.totais-acresc]="(vlrDescGeral || 0) < 0">
            <span class="totais-label">Desc\Acrs. Geral U$</span>
            <span class="totais-valor total-pedido-wrap">
              <span class="total-pedido-valor">{{ vlrDescGeralUsd != null ? '$ ' + formatarDecimal(vlrDescGeralUsd) : '$ 0,00' }}</span>
              <input type="number" class="total-pedido-input" [(ngModel)]="vlrDescGeralUsd"
                step="0.01" placeholder="0,00"
                title="Clique para editar o desconto/acréscimo geral em U$"
                (keydown)="bloquearSinalDuplicado($event)"
                (paste)="bloquearColagemSinalDuplicado($event)"
                (blur)="onDescGeralBlur()">
            </span>
          </div>
          <div class="totais-linha"
               [class.totais-desconto]="(vlrDescGeral || 0) > 0"
               [class.totais-acresc]="(vlrDescGeral || 0) < 0">
            <span class="totais-label">Desc\Acrs. Geral R$</span>
            <span class="totais-valor total-pedido-wrap">
              <span class="total-pedido-valor">{{ vlrDescGeral != null ? formatarMoeda(vlrDescGeral) : formatarMoeda(0) }}</span>
              <input type="number" class="total-pedido-input" [(ngModel)]="vlrDescGeral"
                step="0.01" placeholder="0,00"
                title="Clique para editar o desconto/acréscimo geral em R$"
                (ngModelChange)="onDescGeralVlrChange()"
                (keydown)="bloquearSinalDuplicado($event)"
                (paste)="bloquearColagemSinalDuplicado($event)"
                (blur)="onDescGeralBlur()">
            </span>
          </div>
          <div class="totais-linha" [class.totais-acresc]="(vlrOutros || 0) > 0" *ngIf="false">
            <span class="totais-label">Outros</span>
            <span class="totais-valor total-pedido-wrap">
              <span class="total-pedido-valor">{{ formatarMoeda(vlrOutros || 0) }}</span>
              <input type="number" class="total-pedido-input" [(ngModel)]="vlrOutros"
                step="0.01" placeholder="0,00"
                title="Valor de Outros (VLROUTROS) — somado no Total do Pedido. Pré-preenchido ao importar do Sistema Legado, mas pode ser editado livremente."
                (keydown)="bloquearSinalDuplicado($event)"
                (paste)="bloquearColagemSinalDuplicado($event)">
            </span>
          </div>
        </div>

        <!-- Subtotais e Core exibidos no rodapé da tabela (tfoot) -->


        <!-- Total CORE exibido no rodapé da tabela (tfoot) -->

        <!-- IPI e ST exibidos no rodapé da tabela (tfoot) — removido do painel lateral -->

        <!-- Frete — vindo da aba Dados do Transporte. Só soma no Total do Pedido
             U$/R$ abaixo quando o Tipo do Frete é "Incluso" (ver
             vlrFreteIncluso/totalPedido); em "Extra Nota" o valor aparece aqui
             só como referência, mas não entra no total (frete cobrado à parte).
             Embrulhado em .totais-grupo (mesma largura fixa das outras linhas)
             para o rótulo ficar alinhado com "% Desc\Acrs. Geral" etc. -->
        <div class="totais-grupo" *ngIf="(vlrFrete || 0) > 0">
          <div class="totais-linha totais-frete">
            <span class="totais-label">Frete{{ vlrFreteIncluso ? '' : ' (Extra Nota)' }}</span>
            <span class="totais-valor">{{ formatarMoeda(vlrFrete || 0) }}</span>
          </div>
        </div>

        <!-- Total Final -->
        <div class="totais-sep totais-sep-final"></div>
        <div class="totais-grupo totais-grupo-final">
          <div class="totais-linha totais-final" *ngIf="subtotalUsd > 0">
            <span class="totais-label">Total do Pedido U$</span>
            <span class="totais-valor">$ {{ formatarDecimal(totalPedidoUsd) }}</span>
          </div>
          <div class="totais-linha totais-final">
            <span class="totais-label">Total do Pedido R$</span>
            <span class="totais-valor total-pedido-wrap">
              <span class="total-pedido-valor">{{ formatarMoeda(totalPedido) }}</span>
              <input type="text" class="total-pedido-input"
                [(ngModel)]="totalPedidoDesejadoStr"
                (focus)="onTotalPedidoFocus()"
                (blur)="onTotalPedidoBlur()"
                (keydown.enter)="onTotalPedidoEnter($event)"
                [placeholder]="formatarMoeda(totalPedido)"
                title="Digite o total desejado para ratear o desconto entre os itens">
            </span>
          </div>
        </div>

      </div>
      </div><!-- /itens-rodape-linha -->
    </div>

    <!-- ── CARD COMISSÕES ── -->
    <div *ngIf="abaPrincipalAtiva === 'comissoes'" class="card">
      <div class="card-title">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/>
        </svg>
        Comissionado
        <ng-container *ngIf="clienteSelecionado">
          <div class="ctc-campos">
            <div class="ctc-campo">
              <span class="ctc-label">Cliente</span>
              <span class="ctc-valor">{{ clienteSelecionado.nomeparc }}</span>
            </div>
            <div class="ctc-campo" *ngIf="clienteSelecionado.docparc">
              <span class="ctc-label">CNPJ/CPF</span>
              <span class="ctc-valor">{{ fmtDocumento(clienteSelecionado.docparc) }}</span>
            </div>
            <div class="ctc-campo" *ngIf="clienteSelecionado.inscEstadual">
              <span class="ctc-label">Insc. Estadual</span>
              <span class="ctc-valor">{{ fmtIE(clienteSelecionado.inscEstadual) }}</span>
            </div>
            <div class="ctc-campo" *ngIf="clienteSelecionado.cidade || clienteSelecionado.uf">
              <span class="ctc-label">Cidade / UF</span>
              <span class="ctc-valor">{{ clienteSelecionado.cidade }}<ng-container *ngIf="clienteSelecionado.cidade && clienteSelecionado.uf"> - </ng-container>{{ clienteSelecionado.uf }}</span>
            </div>
          </div>
          <div class="ctc-aeronave" *ngIf="aeronaveAtualPrefixo">
            <span class="ctc-label">Aeronave</span>
            <span class="ctc-valor ctc-aeronave-prefixo">{{ aeronaveAtualPrefixo }}</span>
          </div>
        </ng-container>
      </div>

      <!-- Formulário de adição -->
      <div class="comissao-form">
        <div class="comissao-campo-busca">
          <div class="cliente-titulos-linha">
            <label class="form-label">Parceiro</label>
            <span
              *ngFor="let t of titulosComissaoPosicionados"
              class="cliente-titulo-extra"
              [style.left.px]="t.left"
            >{{ t.label }}</span>
          </div>
          <div class="input-icon-wrap">
            <svg class="cliente-icon-btn" style="pointer-events:none;position:absolute;left:10px;top:50%;transform:translateY(-50%);opacity:.45"
              xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input type="text" class="form-input" style="text-transform: uppercase"
              [style.padding-left.px]="comissaoInputStartX - 1.5" placeholder="Digite o nome do usuário..."
              [(ngModel)]="comissaoBusca"
              (input)="onComissaoInput()"
              (focus)="onComissaoFocus()"
              (blur)="onComissaoBlur()"
              autocomplete="off">
            <button *ngIf="comissaoUsuarioSelecionado" class="input-clear-btn" type="button"
              (click)="comissaoUsuarioSelecionado=null; comissaoBusca=''; comissaoSugestoes=[]; mostrarDropdownComissao=false">✕</button>
            <div class="gpl-copiar-wrap" *ngIf="comissaoUsuarioSelecionado && gplItensCopiaveis('comissao').length > 0">
              <button class="gpl-copiar-btn" type="button" title="Copiar dados" (click)="gplAbrirMenuCopiar('comissao', $event)">⋮</button>
              <div class="gpl-copiar-menu" *ngIf="gplCopiarMenuTipo === 'comissao'">
                <button *ngFor="let item of gplItensCopiaveis('comissao')" type="button" class="gpl-copiar-item" (click)="gplCopiarCampo(item.valor, item.label)">
                  Copiar {{ item.label }}
                </button>
              </div>
            </div>
          </div>
          <!-- Dropdown sugestões -->
          <div class="cliente-dropdown" *ngIf="mostrarDropdownComissao">
            <div *ngIf="comissaoCarregando" class="cliente-dropdown-loading">
              <app-loading-indicator size="inline"></app-loading-indicator> Buscando...
            </div>
            <div *ngIf="!comissaoCarregando && comissaoSugestoes.length === 0" class="cliente-dropdown-vazio">
              Nenhum usuário encontrado
            </div>
            <button *ngFor="let c of comissaoSugestoes" type="button"
              class="cliente-dropdown-item" (click)="selecionarUsuarioComissao(c)">
              <div class="cliente-item-nome">{{ c.nomeparc }}</div>
              <div class="cliente-item-detalhes">
                <span *ngIf="c.docparc">{{ fmtDocumento(c.docparc) }}</span>
                <span *ngIf="c.adCom">{{ c.adCom }}</span>
                <span *ngIf="c.inscEstadual">{{ fmtIE(c.inscEstadual) }}</span>
                <span *ngIf="c.codparc" style="color:#999">Código: {{ c.codparc }}</span>
              </div>
            </button>
          </div>
        </div>
        <div class="comissao-campo-perc">
          <label class="form-label">Percentual (%)</label>
          <input type="number" class="form-input" [(ngModel)]="comissaoPerc"
            min="0" max="100" step="0.01" placeholder="0,00">
        </div>
        <div class="comissao-campo-btn">
          <button type="button" class="btn-primario" (click)="adicionarComissao()"
            [disabled]="comissaoSalvando || !comissaoUsuarioSelecionado || !comissaoPerc">
            <app-loading-indicator *ngIf="comissaoSalvando" size="inline"></app-loading-indicator>
            <svg *ngIf="!comissaoSalvando" xmlns="http://www.w3.org/2000/svg" width="14" height="14"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            Adicionar
          </button>
        </div>
        <div class="comissao-erro" *ngIf="comissaoErro">{{ comissaoErro }}</div>
      </div>

      <!-- Tabela de comissões -->
      <div class="comissao-table-wrap" *ngIf="comissoes.length > 0">
        <table class="comissao-table">
          <thead>
            <tr>
              <th>Usuário</th>
              <th class="col-num">%</th>
              <th class="col-num">Valor R$</th>
              <th class="col-num">Valor U$</th>
              <th class="col-acao"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of comissoes">
              <td>
                <span class="comissao-nome">{{ c.nomeparc }}</span>
                <span class="comissao-cod">Cód. {{ c.codparc }}</span>
              </td>
              <td class="col-num">{{ c.perccomissao | number:'1.2-2' }}%</td>
              <td class="col-num">{{ formatarMoeda(vlrComissaoBrl(c.perccomissao)) }}</td>
              <td class="col-num">{{ totalPedidoUsd > 0 ? '$ ' + formatarDecimal(vlrComissaoUsd(c.perccomissao)) : '—' }}</td>
              <td class="col-acao">
                <button type="button" class="btn-remover-comissao" title="Remover"
                  (click)="removerComissao(c.codpco)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
                    <path d="M10 11v6"/><path d="M14 11v6"/>
                    <path d="M9 6V4h6v2"/>
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="comissao-total-row">
              <td>Total</td>
              <td class="col-num">{{ totalPercComissao | number:'1.2-2' }}%</td>
              <td class="col-num">{{ formatarMoeda(totalVlrComissaoBrl) }}</td>
              <td class="col-num">{{ totalPedidoUsd > 0 ? '$ ' + formatarDecimal(totalVlrComissaoUsd) : '—' }}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div class="comissao-vazio" *ngIf="comissoes.length === 0">
        Nenhuma comissão adicionada. As comissões serão salvas junto com o pedido.
      </div>
    </div>
    </fieldset>

    <!-- Rodapé removido (botão movido para o topo) -->

  </div>
</div>

<!-- Modal de Busca de Vendedor (igual ao "Procurando por Vendedor" do Sankhya) -->
<div class="modal-overlay" *ngIf="vendedorModalAberta">
  <div class="modal-box">
    <div class="modal-header">Procurando por Vendedor</div>
    <div class="modal-body">
      <input type="text"
             class="busca-modal-input"
             [(ngModel)]="filtroVendedor"
             placeholder="Digite o que você procura"
             autofocus>

      <div class="busca-modal-lista">
        <div class="busca-modal-item"
             *ngFor="let v of vendedoresFiltrados"
             (click)="selecionarVendedor(v)">
          {{ v.codVend }} - {{ v.apelido }}
        </div>
        <div class="busca-modal-empty" *ngIf="vendedoresFiltrados.length === 0">
          Nenhum vendedor encontrado.
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="modal-btn confirm" (click)="fecharBuscaVendedor()">Cancelar</button>
    </div>
  </div>
</div>

<!-- Modal de Busca de Cotação (TSICOT — mesma fonte do Demonstrativo de Vendas) -->
<div class="modal-overlay" *ngIf="cotacaoModalAberta">
  <div class="modal-box">
    <div class="modal-header">Cotações Disponíveis</div>
    <div class="modal-body">
      <input type="text"
             class="busca-modal-input"
             [(ngModel)]="filtroCotacao"
             placeholder="Filtrar por cotação ou data...">
      <div class="busca-modal-empty" *ngIf="cotacaoCarregando"><app-loading-indicator size="inline"></app-loading-indicator>
        Buscando...
      </div>
      <div class="busca-modal-lista" *ngIf="!cotacaoCarregando">
        <div class="busca-modal-item"
             *ngFor="let c of cotacoesFiltradas"
             (click)="selecionarCotacao(c)">
          {{ valorCotacaoFormatado(c) }}&nbsp;&nbsp;|&nbsp;&nbsp;{{ dataCotacao(c) }}
        </div>
        <div class="busca-modal-empty" *ngIf="cotacoesFiltradas.length === 0">
          Nenhuma cotação encontrada.
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="modal-btn confirm" (click)="fecharBuscaCotacao()">Cancelar</button>
    </div>
  </div>
</div>

<!-- Modal de Busca de Condição de Pagamento / Tipo Negociação (TGFTPV) -->
<div class="modal-overlay" *ngIf="tipoNegociacaoModalAberta">
  <div class="modal-box">
    <div class="modal-header">Condições de Pagamento Disponíveis</div>
    <div class="modal-body">
      <input type="text"
             class="busca-modal-input"
             [(ngModel)]="filtroTipoNegociacao"
             placeholder="Filtrar por condição de pagamento..."
             autofocus>
      <div class="busca-modal-empty" *ngIf="tiposNegociacaoCarregando"><app-loading-indicator size="inline"></app-loading-indicator>
        Buscando...
      </div>
      <div class="busca-modal-lista" *ngIf="!tiposNegociacaoCarregando">
        <div class="busca-modal-item"
             *ngFor="let t of tiposNegociacaoFiltradas"
             (click)="selecionarTipoNegociacao(t)">
          {{ t.descricao }}
        </div>
        <div class="busca-modal-empty" *ngIf="tiposNegociacaoFiltradas.length === 0">
          Nenhuma condição de pagamento encontrada.
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="modal-btn confirm" (click)="fecharBuscaTipoNegociacao()">Cancelar</button>
    </div>
  </div>
</div>

<!-- Modal de Busca de Centro de Resultado (TGFCEN) -->
<div class="modal-overlay" *ngIf="centroResultadoModalAberta">
  <div class="modal-box">
    <div class="modal-header">Centros de Resultado Disponíveis</div>
    <div class="modal-body">
      <input type="text"
             class="busca-modal-input"
             [(ngModel)]="filtroCentroResultado"
             placeholder="Filtrar por centro de resultado..."
             autofocus>
      <div class="busca-modal-empty" *ngIf="centrosResultadoCarregando"><app-loading-indicator size="inline"></app-loading-indicator>
        Buscando...
      </div>
      <div class="busca-modal-lista" *ngIf="!centrosResultadoCarregando">
        <div class="busca-modal-item"
             *ngFor="let c of centrosResultadoFiltrados"
             (click)="selecionarCentroResultado(c)">
          {{ c.codCen }} - {{ c.descricao }}
        </div>
        <div class="busca-modal-empty" *ngIf="centrosResultadoFiltrados.length === 0">
          Nenhum centro de resultado encontrado.
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="modal-btn confirm" (click)="fecharBuscaCentroResultado()">Cancelar</button>
    </div>
  </div>
</div>

<!-- Modal de Busca de Natureza (TGFNAT) -->
<div class="modal-overlay" *ngIf="naturezaModalAberta">
  <div class="modal-box">
    <div class="modal-header">Naturezas Disponíveis</div>
    <div class="modal-body">
      <input type="text"
             class="busca-modal-input"
             [(ngModel)]="filtroNatureza"
             placeholder="Filtrar por natureza..."
             autofocus>
      <div class="busca-modal-empty" *ngIf="naturezasCarregando"><app-loading-indicator size="inline"></app-loading-indicator>
        Buscando...
      </div>
      <div class="busca-modal-lista" *ngIf="!naturezasCarregando">
        <div class="busca-modal-item"
             *ngFor="let n of naturezasFiltradas"
             (click)="selecionarNatureza(n)">
          {{ n.codNat }} - {{ n.descricao }}
        </div>
        <div class="busca-modal-empty" *ngIf="naturezasFiltradas.length === 0">
          Nenhuma natureza encontrada.
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="modal-btn confirm" (click)="fecharBuscaNatureza()">Cancelar</button>
    </div>
  </div>
</div>

<!-- Modal de Busca de Aeronave -->
<div class="modal-overlay" *ngIf="aeronaveModalAberta">
  <div class="modal-box">
    <div class="modal-header">Procurando por Aeronave</div>
    <div class="modal-body">
      <input type="text"
             class="busca-modal-input"
             [(ngModel)]="filtroAeronaveModal"
             (ngModelChange)="onFiltroAeronaveModalChange()"
             placeholder="Digite o prefixo..."
             autofocus>
      <div class="busca-modal-lista">
        <div *ngIf="aeronaveModalCarregando" class="busca-modal-msg"><app-loading-indicator size="inline"></app-loading-indicator> Buscando...</div>
        <div *ngIf="!aeronaveModalCarregando && aeronaveSugestoesModal.length === 0 && filtroAeronaveModal.length >= 2"
             class="busca-modal-msg">Nenhuma aeronave encontrada.</div>
        
        <div *ngFor="let a of aeronaveSugestoesModal"
             class="busca-modal-item"
             (click)="selecionarAeronaveModal(a)">
          <div class="modal-item-nome">{{ a.prefixo }}</div>
          <div class="cliente-item-detalhes">
            <span *ngIf="a.nomeProprietario">Propr.: {{ a.nomeProprietario }}</span>
            <span *ngIf="a.tipoVinculo">{{ a.tipoVinculoDescricao || formatarVinculo(a.tipoVinculo) }}</span>
            <span style="color:#999">CODAERO: {{ a.codaero }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="modal-btn confirm" (click)="fecharBuscaAeronave()">Cancelar</button>
    </div>
  </div>
</div>

<!-- Modal de Busca de Cliente (igual ao "Procurando por Cliente" do Sankhya) -->
<div class="modal-overlay" *ngIf="clienteModalAberta">
  <div class="modal-box">
    <div class="modal-header">Procurando por Cliente</div>
    <div class="modal-body">
      <input type="text"
             class="busca-modal-input"
             [(ngModel)]="filtroClienteModal"
             (ngModelChange)="onFiltroClienteModalChange()"
             placeholder="Digite o nome ou CNPJ/CPF..."
             autofocus>
      <div class="busca-modal-lista">
        <div class="busca-modal-empty" *ngIf="clienteModalCarregando"><app-loading-indicator size="inline"></app-loading-indicator>
          Buscando...
        </div>
        <div class="busca-modal-item"
             *ngFor="let c of clienteSugestoesModal"
             (click)="selecionarClienteModal(c)">
          <div class="cliente-item-nome">{{ c.nomeparc }}</div>
          <div class="cliente-item-detalhes">
            <span *ngIf="c.docparc">{{ fmtDocumento(c.docparc) }}</span>
            <span *ngIf="c.adCom">{{ c.adCom }}</span>
            <span *ngIf="c.inscEstadual">{{ fmtIE(c.inscEstadual) }}</span>
          </div>
        </div>
        <div class="busca-modal-empty" *ngIf="!clienteModalCarregando && filtroClienteModal.trim().length >= 2 && clienteSugestoesModal.length === 0">
          Nenhum cliente encontrado.
        </div>
        <div class="busca-modal-empty" *ngIf="filtroClienteModal.trim().length < 2">
          Digite ao menos 2 caracteres.
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="modal-btn confirm" (click)="fecharBuscaCliente()">Cancelar</button>
    </div>
  </div>
</div>


<!-- Modal de Seleção de Produto (PN com múltiplos resultados) -->
<div class="modal-overlay" *ngIf="produtoModalAberta">
  <div class="modal-box modal-box-produtos">
    <div class="modal-header">Múltiplos produtos encontrados — selecione um</div>
    <div class="modal-body">
      <div class="busca-modal-lista">
        <div class="busca-modal-item peca-card"
             *ngFor="let p of produtoModalLista"
             (click)="selecionarProdutoModal(p)">
          <div class="peca-grid">
            <div class="peca-col">
              <span class="peca-lbl">PN</span>
              <span class="peca-pn">{{ p.referencia ?? p.refforn ?? '—' }}</span>
            </div>
            <div class="peca-col">
              <span class="peca-lbl">COND.</span>
              <span class="peca-cod">{{ p.condicao || '—' }}</span>
            </div>
            <div class="peca-col">
              <span class="peca-lbl">DESCRIÇÃO</span>
              <span class="peca-descricao">{{ p.descricao }}</span>
            </div>
          </div>
          <div class="peca-meta">Cód: {{ p.codprod }} &nbsp;·&nbsp; UN: {{ p.codvol ?? '—' }}<ng-container *ngIf="p.marca"> &nbsp;·&nbsp; Fab: {{ p.marca }}</ng-container></div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="modal-btn" (click)="fecharProdutoModal()">Cancelar</button>
    </div>
  </div>
</div>

<!-- Modal de Busca de Peças (F3 / Enter no campo PN) -->
<div class="modal-overlay" *ngIf="buscaPecasAberta" (keydown.escape)="fecharBuscaPecas()">
  <div class="modal-box modal-box-pecas" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <span>Busca de Peças</span>
      <button type="button" class="modal-close-btn" (click)="fecharBuscaPecas()">✕</button>
    </div>

    <!-- Campo de busca fixo no topo -->
    <div class="busca-pecas-header">
      <div class="busca-pecas-campo-unico">
        <svg class="busca-pecas-icone" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
        <input type="text" class="busca-pecas-input-unico"
               [(ngModel)]="buscaPecasTermo"
               (ngModelChange)="onBuscaPecasInput()"
               (keydown)="onBuscaPecasKeydown($event)"
               placeholder="Digite o PN (ex: 010-11654) ou descrição (ex: ACUMULADOR GPS)..."
               autocomplete="off">
        <app-loading-indicator *ngIf="buscaPecasCarregando" size="inline"></app-loading-indicator>
      </div>
      <div class="busca-pecas-dica">Busca por PN ou descrição · Mínimo 2 caracteres</div>
    </div>

    <!-- Área de resultados rolável -->
    <div class="busca-pecas-lista-area">
      <div *ngIf="buscaPecasSemResultado && !buscaPecasCarregando" class="busca-modal-empty">Nenhuma peça encontrada.</div>

      <div *ngIf="buscaPecasResultados.length > 0" class="busca-pecas-lista">
        <table class="busca-pecas-tabela">
          <thead>
            <tr>
              <th class="th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'pn'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('pn')" (click)="toggleFiltroBusca('pn', $event)" [title]="temFiltroBusca('pn') ? ('Filtro: ' + filtrosBusca['pn']) : 'Clique para filtrar'">PN</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='pn'" (click)="ordenarBuscaPecas('pn')">{{ buscaPecasOrdenarCampo==='pn' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('pn')" class="th-filtro-limpar" (click)="limparFiltroBusca('pn', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'pn'" id="filtro-busca-pn" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['pn']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('pn'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'cd'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('cd')" (click)="toggleFiltroBusca('cd', $event)" [title]="temFiltroBusca('cd') ? ('Filtro: ' + filtrosBusca['cd']) : 'Clique para filtrar'">CD</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='cd'" (click)="ordenarBuscaPecas('cd')">{{ buscaPecasOrdenarCampo==='cd' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('cd')" class="th-filtro-limpar" (click)="limparFiltroBusca('cd', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'cd'" id="filtro-busca-cd" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['cd']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('cd'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'descricao'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('descricao')" (click)="toggleFiltroBusca('descricao', $event)" [title]="temFiltroBusca('descricao') ? ('Filtro: ' + filtrosBusca['descricao']) : 'Clique para filtrar'">Descrição</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='descricao'" (click)="ordenarBuscaPecas('descricao')">{{ buscaPecasOrdenarCampo==='descricao' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('descricao')" class="th-filtro-limpar" (click)="limparFiltroBusca('descricao', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'descricao'" id="filtro-busca-descricao" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['descricao']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('descricao'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'un'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('un')" (click)="toggleFiltroBusca('un', $event)" [title]="temFiltroBusca('un') ? ('Filtro: ' + filtrosBusca['un']) : 'Clique para filtrar'">UN</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='un'" (click)="ordenarBuscaPecas('un')">{{ buscaPecasOrdenarCampo==='un' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('un')" class="th-filtro-limpar" (click)="limparFiltroBusca('un', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'un'" id="filtro-busca-un" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['un']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('un'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="text-right th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'estoque'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('estoque')" (click)="toggleFiltroBusca('estoque', $event)" [title]="temFiltroBusca('estoque') ? ('Filtro: ' + filtrosBusca['estoque']) : 'Clique para filtrar'">Estoque</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='estoque'" (click)="ordenarBuscaPecas('estoque')">{{ buscaPecasOrdenarCampo==='estoque' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('estoque')" class="th-filtro-limpar" (click)="limparFiltroBusca('estoque', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'estoque'" id="filtro-busca-estoque" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['estoque']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('estoque'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <!-- Valor Moeda / Valor R$ (sem IPI) ocultas a pedido do usuário — mantidas
                   comentadas (não removidas) caso precisem voltar. Ver também os <td>
                   correspondentes nas linhas do item principal e dos alternativos abaixo,
                   e o colspan="13" da faixa "PRODUTOS ALTERNATIVOS" (era 15). -->
              <!-- <th class="text-right">Valor Moeda</th> -->
              <!-- <th class="text-right">Valor R$</th> -->
              <th class="text-right th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'valorMoedaIpi'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('valorMoedaIpi')" (click)="toggleFiltroBusca('valorMoedaIpi', $event)" [title]="temFiltroBusca('valorMoedaIpi') ? ('Filtro: ' + filtrosBusca['valorMoedaIpi']) : 'Clique para filtrar'">VALOR U$ + IPI</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='valorMoedaIpi'" (click)="ordenarBuscaPecas('valorMoedaIpi')">{{ buscaPecasOrdenarCampo==='valorMoedaIpi' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('valorMoedaIpi')" class="th-filtro-limpar" (click)="limparFiltroBusca('valorMoedaIpi', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'valorMoedaIpi'" id="filtro-busca-valorMoedaIpi" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['valorMoedaIpi']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('valorMoedaIpi'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="text-right th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'valorReaisIpi'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('valorReaisIpi')" (click)="toggleFiltroBusca('valorReaisIpi', $event)" [title]="temFiltroBusca('valorReaisIpi') ? ('Filtro: ' + filtrosBusca['valorReaisIpi']) : 'Clique para filtrar'">Valor R$ + IPI</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='valorReaisIpi'" (click)="ordenarBuscaPecas('valorReaisIpi')">{{ buscaPecasOrdenarCampo==='valorReaisIpi' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('valorReaisIpi')" class="th-filtro-limpar" (click)="limparFiltroBusca('valorReaisIpi', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'valorReaisIpi'" id="filtro-busca-valorReaisIpi" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['valorReaisIpi']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('valorReaisIpi'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="text-right th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'vlrIpi'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('vlrIpi')" (click)="toggleFiltroBusca('vlrIpi', $event)" [title]="temFiltroBusca('vlrIpi') ? ('Filtro: ' + filtrosBusca['vlrIpi']) : 'Clique para filtrar'">VLR IPI</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='vlrIpi'" (click)="ordenarBuscaPecas('vlrIpi')">{{ buscaPecasOrdenarCampo==='vlrIpi' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('vlrIpi')" class="th-filtro-limpar" (click)="limparFiltroBusca('vlrIpi', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'vlrIpi'" id="filtro-busca-vlrIpi" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['vlrIpi']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('vlrIpi'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'fabricante'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('fabricante')" (click)="toggleFiltroBusca('fabricante', $event)" [title]="temFiltroBusca('fabricante') ? ('Filtro: ' + filtrosBusca['fabricante']) : 'Clique para filtrar'">Fabricante</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='fabricante'" (click)="ordenarBuscaPecas('fabricante')">{{ buscaPecasOrdenarCampo==='fabricante' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('fabricante')" class="th-filtro-limpar" (click)="limparFiltroBusca('fabricante', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'fabricante'" id="filtro-busca-fabricante" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['fabricante']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('fabricante'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th>Origem</th>
              <th class="text-right th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'dataUltAtual'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('dataUltAtual')" (click)="toggleFiltroBusca('dataUltAtual', $event)" [title]="temFiltroBusca('dataUltAtual') ? ('Filtro: ' + filtrosBusca['dataUltAtual']) : 'Clique para filtrar'">Data Ult. Atual. Preço</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='dataUltAtual'" (click)="ordenarBuscaPecas('dataUltAtual')">{{ buscaPecasOrdenarCampo==='dataUltAtual' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('dataUltAtual')" class="th-filtro-limpar" (click)="limparFiltroBusca('dataUltAtual', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'dataUltAtual'" id="filtro-busca-dataUltAtual" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['dataUltAtual']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('dataUltAtual'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="text-right th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'limiteDias'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('limiteDias')" (click)="toggleFiltroBusca('limiteDias', $event)" [title]="temFiltroBusca('limiteDias') ? ('Filtro: ' + filtrosBusca['limiteDias']) : 'Clique para filtrar'">Limite p/ Atual. (Dias)</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='limiteDias'" (click)="ordenarBuscaPecas('limiteDias')">{{ buscaPecasOrdenarCampo==='limiteDias' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('limiteDias')" class="th-filtro-limpar" (click)="limparFiltroBusca('limiteDias', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'limiteDias'" id="filtro-busca-limiteDias" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['limiteDias']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('limiteDias'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'alternativo'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('alternativo')" (click)="toggleFiltroBusca('alternativo', $event)" [title]="temFiltroBusca('alternativo') ? ('Filtro: ' + filtrosBusca['alternativo']) : 'Clique para filtrar'">Alternativo</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='alternativo'" (click)="ordenarBuscaPecas('alternativo')">{{ buscaPecasOrdenarCampo==='alternativo' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('alternativo')" class="th-filtro-limpar" (click)="limparFiltroBusca('alternativo', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'alternativo'" id="filtro-busca-alternativo" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['alternativo']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('alternativo'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
              <th class="text-right th-ordenavel">
                <ng-container *ngIf="colunaFiltroAberta !== 'codigo'"><span class="th-label" [class.th-label-filtrado]="temFiltroBusca('codigo')" (click)="toggleFiltroBusca('codigo', $event)" [title]="temFiltroBusca('codigo') ? ('Filtro: ' + filtrosBusca['codigo']) : 'Clique para filtrar'">Código</span><span class="th-seta" [class.th-seta-ativa]="buscaPecasOrdenarCampo==='codigo'" (click)="ordenarBuscaPecas('codigo')">{{ buscaPecasOrdenarCampo==='codigo' ? (buscaPecasOrdemAsc ? ' ▲' : ' ▼') : ' ⇅' }}</span><span *ngIf="temFiltroBusca('codigo')" class="th-filtro-limpar" (click)="limparFiltroBusca('codigo', $event)" title="Limpar filtro">✕</span></ng-container>
                <input *ngIf="colunaFiltroAberta === 'codigo'" id="filtro-busca-codigo" type="text" class="th-filtro-input-inline" [(ngModel)]="filtrosBusca['codigo']" [ngModelOptions]="{standalone:true}" (click)="$event.stopPropagation()" (blur)="fecharFiltroBusca()" (keydown.enter)="fecharFiltroBusca()" (keydown.escape)="limparFiltroBusca('codigo'); fecharFiltroBusca()" placeholder="Filtrar...">
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="buscaPecasResultadosExibidos.length === 0">
              <td colspan="14" class="busca-modal-empty">Nenhum resultado para os filtros de coluna aplicados.</td>
            </tr>
            <ng-container *ngFor="let p of buscaPecasResultadosExibidos">

              <!-- Linha do item principal -->
              <tr class="busca-pecas-linha"
                  [class.busca-pecas-linha-selecionada]="buscaPecasProdutoSelecionado === p"
                  [class.bp-sem-preco]="p.vlrVenda == null || p.vlrVenda <= 0"
                  [class.bp-preco-desatualizado]="p.precoDesatualizado && p.vlrVenda > 0"
                  (click)="selecionarProdutoParaDetalhe(p)"
                  (dblclick)="selecionarPecaModal(p)">
                <td class="bp-pn">{{ p.refforn ?? p.referencia ?? p.codprod }}</td>
                <td class="bp-cd">{{ p.condicao || '—' }}</td>
                <td class="bp-desc">{{ p.descricao }}</td>
                <td class="bp-un">{{ p.codvol ?? 'UN' }}</td>
                <td class="bp-estoque text-right"
                    [class.estoque-zero]="(p.estoque ?? 0) <= 0">
                  {{ p.estoque != null ? (fmtQtd(p.estoque, p.codvol)) : '—' }}
                </td>
                <!-- <td class="bp-preco text-right">{{ p.vlrVenda != null ? (p.vlrVenda | number:'1.2-2':'pt-BR') : '—' }}</td> -->
                <!-- <td class="bp-preco text-right">{{ valorEmReaisBusca(p.vlrVenda, p.origemNacional, cotacaoValorNumerico) != null ? (valorEmReaisBusca(p.vlrVenda, p.origemNacional, cotacaoValorNumerico) | number:'1.2-2':'pt-BR') : '—' }}</td> -->
                <td class="bp-preco text-right">{{ valorMoedaComIpiBusca(p, cotacaoValorNumerico) != null ? (valorMoedaComIpiBusca(p, cotacaoValorNumerico) | number:'1.2-2':'pt-BR') : '—' }}</td>
                <td class="bp-preco text-right">{{ valorReaisComIpiBusca(p, cotacaoValorNumerico) != null ? (valorReaisComIpiBusca(p, cotacaoValorNumerico) | number:'1.2-2':'pt-BR') : '—' }}</td>
                <td class="bp-preco text-right">{{ p.vlrVenda != null ? (vlrIpiUnitarioBusca(p, cotacaoValorNumerico) | number:'1.2-2':'pt-BR') : '—' }}</td>
                <td class="bp-marca">{{ p.marca || '—' }}</td>
                <!-- Indicador Nacional/Internacional oculto por enquanto (a pedido do usuário) -->
                <td class="bp-origem">
                  <span *ngIf="false && p.origem" class="origem-badge" [class.origem-badge-nacional]="p.origemNacional">{{ p.origem }}</span>
                  <span>—</span>
                </td>
                <td class="bp-preco text-right">{{ p.dataUltAtualPreco || '—' }}</td>
                <td class="bp-preco text-right">{{ p.limitePrazoAtualDias > 0 ? p.limitePrazoAtualDias : '—' }}</td>
                <td class="bp-alt">{{ p.alternativo || '—' }}</td>
                <td class="bp-preco text-right">{{ p.codprod ?? '—' }}</td>
              </tr>

              <!-- Sub-lista de alternativos — permanece visível mesmo ao selecionar um dos
                   alternativos abaixo (por isso usa buscaPecasProdutoExpandido, não
                   buscaPecasProdutoSelecionado, que muda para o alternativo clicado). -->
              <ng-container *ngIf="buscaPecasProdutoExpandido === p">

                <!-- Sem linha de "Carregando…": evita o flash de expandir/recolher quando o
                     item nao tem alternativos (causava a tela tremendo). So exibe algo quando
                     a busca termina E ha ao menos 1 alternativo. -->

                <!-- Faixa + linhas: só exibe quando há ao menos 1 alternativo -->
                <ng-container *ngIf="!buscaPecasAlternativosCarregando && buscaPecasAlternativos.length > 0">
                  <tr>
                    <td colspan="14" class="bp-alt-faixa">
                      PRODUTOS ALTERNATIVOS
                      <span class="bp-alt-badge">{{ buscaPecasAlternativos.length }}</span>
                    </td>
                  </tr>
                  <tr *ngFor="let a of buscaPecasAlternativos"
                      class="busca-pecas-linha bp-alt-row"
                      [class.busca-pecas-linha-selecionada]="buscaPecasProdutoSelecionado === a"
                      [class.bp-sem-preco]="a.vlrVenda == null || a.vlrVenda <= 0"
                      (click)="selecionarAlternativoParaDetalhe(a)"
                      (dblclick)="selecionarPecaModal(a)">
                    <td class="bp-pn bp-alt-pn">
                      <span *ngIf="a.substituto === 'S'" class="busca-pecas-alt-subst" title="Substituto direto">★</span>
                      {{ a.refforn }}
                    </td>
                    <td class="bp-cd">{{ a.condicao || '—' }}</td>
                    <td class="bp-desc">{{ a.descricao }}</td>
                    <td class="bp-un">{{ a.codvol ?? 'UN' }}</td>
                    <td class="bp-estoque text-right"
                        [class.estoque-zero]="!a.estoqueTotal || a.estoqueTotal === 0">
                      {{ a.estoqueTotal > 0 ? (fmtQtd(a.estoqueTotal, a.codvol)) : '0' }}
                    </td>
                    <!-- <td class="bp-preco text-right">{{ a.vlrVenda != null ? (a.vlrVenda | number:'1.2-2':'pt-BR') : '—' }}</td> -->
                    <!-- <td class="bp-preco text-right">{{ valorEmReaisBusca(a.vlrVenda, a.origemNacional, cotacaoValorNumerico) != null ? (valorEmReaisBusca(a.vlrVenda, a.origemNacional, cotacaoValorNumerico) | number:'1.2-2':'pt-BR') : '—' }}</td> -->
                    <td class="bp-preco text-right">{{ valorMoedaComIpiBusca(a, cotacaoValorNumerico) != null ? (valorMoedaComIpiBusca(a, cotacaoValorNumerico) | number:'1.2-2':'pt-BR') : '—' }}</td>
                    <td class="bp-preco text-right">{{ valorReaisComIpiBusca(a, cotacaoValorNumerico) != null ? (valorReaisComIpiBusca(a, cotacaoValorNumerico) | number:'1.2-2':'pt-BR') : '—' }}</td>
                    <td class="bp-preco text-right">{{ a.vlrVenda != null ? (vlrIpiUnitarioBusca(a, cotacaoValorNumerico) | number:'1.2-2':'pt-BR') : '—' }}</td>
                    <td class="bp-marca">{{ a.marca || '—' }}</td>
                    <!-- Indicador Nacional/Internacional oculto por enquanto (a pedido do usuário) -->
                    <td class="bp-origem">
                      <span *ngIf="false && a.origem" class="origem-badge" [class.origem-badge-nacional]="a.origemNacional">{{ a.origem }}</span>
                      <span>—</span>
                    </td>
                    <td class="bp-preco text-right">—</td>
                    <td class="bp-preco text-right">—</td>
                    <td class="bp-alt">{{ a.alternativo || '—' }}</td>
                    <td class="bp-preco text-right">{{ a.codprod ?? '—' }}</td>
                  </tr>
                </ng-container>

              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div><!-- /lista-area -->

    <!-- Painel de Estoque por Local + Imagem — fixo na parte inferior, aparece ao selecionar item -->
    <div class="busca-pecas-estoque-fixo" *ngIf="buscaPecasProdutoSelecionado">
      <div class="bp-estoque-coluna">
        <div class="busca-pecas-estoque-titulo">
          Estoque por Local —
          <strong>{{ buscaPecasProdutoSelecionado.refforn ?? buscaPecasProdutoSelecionado.referencia }}
          {{ buscaPecasProdutoSelecionado.descricao }}</strong>
        </div>

        <div *ngIf="buscaPecasLocaisCarregando" class="bp-estoque-loading"><app-loading-indicator size="inline"></app-loading-indicator> Carregando estoque</div>

        <div *ngIf="!buscaPecasLocaisCarregando && buscaPecasLocais.length === 0" class="bp-estoque-vazio">
          Sem registros de estoque para esta peça.
        </div>

        <div class="busca-pecas-estoque-scroll" *ngIf="!buscaPecasLocaisCarregando && buscaPecasLocais.length > 0">
          <table class="busca-pecas-estoque-tabela">
            <thead>
              <tr>
                <th class="bp-emp">Empresa</th>
                <th class="bp-local">Local</th>
                <th class="bp-num">Total</th>
                <th class="bp-num">Reservado</th>
                <th class="bp-num">Disponível</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let loc of buscaPecasLocais"
                  [style.background-color]="corLinhaEstoque(loc.codemp)"
                  [class.bp-row-zero]="(loc.disponivel ?? 0) <= 0">
                <td class="bp-emp">
                  <span class="bp-emp-cod">{{ loc.codemp }}</span>
                  {{ loc.nomeEmp }}
                </td>
                <td class="bp-local">{{ loc.descrLocal }}</td>
                <td class="bp-num">{{ fmtQtdEstoqueLocal(loc.qtdTotal) }}</td>
                <td class="bp-num bp-reservado">{{ fmtQtdEstoqueLocal(loc.qtdReservada) }}</td>
                <td class="bp-num"
                    [class.bp-disp-pos]="(loc.disponivel ?? 0) > 0"
                    [class.bp-disp-zero]="(loc.disponivel ?? 0) <= 0">
                  {{ fmtQtdEstoqueLocal(loc.disponivel) }}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="bp-row-total">
                <td colspan="2">Total</td>
                <td class="bp-num">{{ fmtQtdEstoqueLocal(buscaTotalLocais('qtdTotal')) }}</td>
                <td class="bp-num">{{ fmtQtdEstoqueLocal(buscaTotalLocais('qtdReservada')) }}</td>
                <td class="bp-num">{{ fmtQtdEstoqueLocal(buscaTotalLocais('disponivel')) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div><!-- /bp-estoque-coluna -->

      <!-- Imagem do produto selecionado — lado direito -->
      <div class="bp-imagem-coluna">
        <div *ngIf="buscaPecasImagemCarregando" class="bp-imagem-loading"><app-loading-indicator></app-loading-indicator> </div>
        <img *ngIf="!buscaPecasImagemCarregando && buscaPecasImagemUrl"
             [src]="buscaPecasImagemUrl"
             class="bp-imagem-produto"
             alt="Imagem do produto"
             title="Clique para ampliar"
             (click)="abrirPreviewImagemBusca()">
        <div *ngIf="!buscaPecasImagemCarregando && !buscaPecasImagemUrl" class="bp-imagem-vazia">
          Sem imagem cadastrada
        </div>
        <!-- Miniaturas — só aparece quando o produto tem mais de uma imagem cadastrada -->
        <div class="bp-imagem-miniaturas" *ngIf="!buscaPecasImagemCarregando && buscaPecasImagensExtras.length > 1">
          <img *ngFor="let img of buscaPecasImagensExtras; let i = index"
               [src]="img"
               class="bp-imagem-miniatura"
               [class.ativa]="i === buscaPecasImagemIndexAtivo"
               alt="Miniatura do produto"
               (click)="selecionarImagemBusca(i)">
        </div>
      </div><!-- /bp-imagem-coluna -->
    </div><!-- /estoque-fixo -->

    <div class="modal-footer bp-footer-com-legenda">
      <!-- Legenda das cores de destaque da tabela -->
      <div class="itens-legenda bp-legenda-footer">
        <span class="legenda-item"><span class="legenda-dot legenda-dot-amarelo"></span>Sem Preço</span>
        <span class="legenda-item"><span class="legenda-dot legenda-dot-vermelho"></span>Preço Desatualizado</span>
      </div>
      <div class="bp-footer-botoes">
        <button type="button" class="modal-btn" (click)="fecharBuscaPecas()">Cancelar</button>
        <button type="button" class="modal-btn-primary"
                *ngIf="buscaPecasProdutoSelecionado"
                (click)="confirmarSelecaoPeca()">
          ✓ Usar esta peça
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ── Preview ampliado da imagem do produto (F3/F7) ───────────────── -->
<div class="modal-overlay imagem-preview-overlay" *ngIf="imagemPreviewAberta"
     (click)="fecharPreviewImagemBusca()" (keydown.escape)="fecharPreviewImagemBusca()">
  <div class="imagem-preview-box" (click)="$event.stopPropagation()">
    <button type="button" class="imagem-preview-fechar" (click)="fecharPreviewImagemBusca()" title="Fechar">✕</button>
    <div class="imagem-preview-img-wrap">
      <img [src]="buscaPecasImagemUrl" class="imagem-preview-img" alt="Imagem do produto ampliada">
    </div>
    <!-- Miniaturas — só aparece quando o produto tem mais de uma imagem cadastrada -->
    <div class="imagem-preview-miniaturas" *ngIf="buscaPecasImagensExtras.length > 1">
      <img *ngFor="let img of buscaPecasImagensExtras; let i = index"
           [src]="img"
           class="imagem-preview-miniatura"
           [class.ativa]="i === buscaPecasImagemIndexAtivo"
           alt="Miniatura do produto"
           (click)="selecionarImagemBusca(i)">
    </div>
  </div>
</div>

<!-- ── Modal: Confirmação de Estoque Insuficiente ───────────────── -->
<div class="modal-overlay" *ngIf="confirmacaoEstoqueAberta">
  <div class="modal-box modal-box-confirmacao" (click)="$event.stopPropagation()">
    <div class="modal-header modal-header-aviso">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
           fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
        <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
      </svg>
      Estoque Insuficiente
    </div>
    <div class="modal-body">
      <p class="confirmacao-texto">
        Os itens abaixo possuem estoque insuficiente na empresa selecionada.
        Deseja gravar o pedido mesmo assim?
      </p>
      <div class="confirmacao-tabela-scroll">
        <table class="confirmacao-tabela">
          <thead>
            <tr>
              <th>PN</th>
              <th>Descrição</th>
              <th class="text-right">Qtd Pedido</th>
              <th class="text-right">Estoque</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let it of confirmacaoEstoqueItens" class="confirmacao-row-zero">
              <td>{{ it.pn }}</td>
              <td>{{ it.descricao }}</td>
              <td class="text-right">{{ fmtQtd(it.qtd, it.unidade) }}</td>
              <td class="text-right confirmacao-saldo-zero">{{ fmtQtd(it.estoque, it.unidade) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="modal-btn" (click)="cancelarConfirmacaoEstoque()">Não, cancelar</button>
      <button type="button" class="modal-btn-primary modal-btn-aviso" (click)="confirmarGravarComEstoqueInsuficiente()">
        Sim, gravar mesmo assim
      </button>
    </div>
  </div>
</div>

<!-- ── Modal: Confirmação de remoção de item ──────────────────────── -->
<div class="modal-overlay" *ngIf="confirmarRemocaoAberta" (click)="cancelarRemocaoItem()">
  <div class="modal-box modal-box-confirmacao" (click)="$event.stopPropagation()">
    <div class="modal-header modal-header-aviso">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
           fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/>
        <path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/>
      </svg>
      Remover Item
    </div>
    <div class="modal-body">
      <p class="confirmacao-texto">Deseja realmente remover este item do pedido?</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="modal-btn" (click)="cancelarRemocaoItem()">Não, cancelar</button>
      <button type="button" class="modal-btn-primary modal-btn-aviso" (click)="confirmarRemocaoItem()">
        Sim, remover
      </button>
    </div>
  </div>
</div>

<!-- ── Modal: Aviso (OK simples) ──────────────────────────────────── -->
<div class="modal-overlay" *ngIf="modalAvisoAberto">
  <div class="modal-box modal-box-confirmacao" (click)="$event.stopPropagation()">
    <div class="modal-header modal-header-aviso">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      Atenção
    </div>
    <div class="modal-body modal-conflito-body">
      <p>{{ modalAvisoMensagem }}</p>
    </div>
    <div class="modal-footer modal-conflito-footer">
      <button type="button" id="pv-modal-aviso-ok" class="modal-btn-primary" (click)="fecharModalAviso()">OK</button>
    </div>
  </div>
</div>

<!-- ── Modal: Conflito Desconto/Acréscimo ao Editar Total ──────────── -->
<div class="modal-overlay" *ngIf="modalConflitoAberto">
  <div class="modal-box modal-box-confirmacao" (click)="$event.stopPropagation()">
    <div class="modal-header modal-header-aviso">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
           fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
      Atenção
    </div>
    <div class="modal-body modal-conflito-body">
      <p>{{ modalConflitoMensagem }}</p>
    </div>
    <div class="modal-footer modal-conflito-footer">
      <button type="button" class="modal-btn" (click)="onModalConflito('cancelar')">Cancelar</button>
      <button type="button" class="modal-btn modal-btn-secondary" (click)="onModalConflito('op2')">
        {{ modalConflitoOp2Label }}
      </button>
      <button type="button" class="modal-btn-primary" (click)="onModalConflito('op1')">
        {{ modalConflitoOp1Label }}
      </button>
    </div>
  </div>
</div>

<!-- ── Modal: Importação de Excel ──────────────────────────────────── -->
<div class="modal-overlay" *ngIf="excelImportAberto" (click)="fecharImportacaoExcel()">
  <div class="modal-box excel-import-box" (click)="$event.stopPropagation()">

    <!-- Cabeçalho -->
    <div class="modal-header excel-import-header">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="12" y1="18" x2="12" y2="12"/>
        <line x1="9" y1="15" x2="12" y2="18"/><line x1="15" y1="15" x2="12" y2="18"/>
      </svg>
      {{ excelImportOrigemOS ? 'Itens da Ordem de Serviço' : 'Importar Itens do Excel' }}
      <span class="excel-import-filename" *ngIf="excelImportNomeArquivo">— {{ excelImportNomeArquivo }}</span>
    </div>

    <!-- Loading -->
    <div class="excel-import-loading" *ngIf="excelImportValidando">
      <app-loading-indicator size="inline"></app-loading-indicator>
      {{ excelMapeamentoAberto ? 'Lendo arquivo...' : 'Validando PNs no sistema...' }}
    </div>

    <!-- Gravando automaticamente (O.S com tudo encontrado) — cobre a tela até terminar -->
    <div class="excel-import-loading" *ngIf="excelImportGravando">
      <app-loading-indicator size="inline"></app-loading-indicator>
      Gravando pedido de venda...
    </div>

    <!-- ===== MAPEAMENTO MANUAL DE COLUNAS ===== -->
    <div class="excel-mapeamento" *ngIf="excelMapeamentoAberto && !excelImportValidando">
      <div class="excel-map-aviso">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        Não foi possível identificar as colunas automaticamente.
        Indique quais colunas correspondem ao <strong>PN</strong> e à <strong>Quantidade</strong>.
      </div>

      <!-- Seletores de colunas -->
      <div class="excel-map-selects">
        <div class="excel-map-campo">
          <label class="excel-map-label">Coluna de PN (Part Number)</label>
          <select class="excel-map-select" [(ngModel)]="excelColunaPn">
            <option [ngValue]="null">— Selecionar coluna —</option>
            <option *ngFor="let col of excelColunas; let i = index" [ngValue]="i">
              {{ col }}
            </option>
          </select>
        </div>
        <div class="excel-map-campo">
          <label class="excel-map-label">Coluna de Quantidade</label>
          <select class="excel-map-select" [(ngModel)]="excelColunaQty">
            <option [ngValue]="null">— Selecionar coluna —</option>
            <option *ngFor="let col of excelColunas; let i = index" [ngValue]="i">
              {{ col }}
            </option>
          </select>
        </div>
      </div>

      <!-- Prévia dos dados do Excel -->
      <div class="excel-map-preview-wrap" *ngIf="excelPreviewLinhas.length > 0">
        <p class="excel-map-preview-label">Prévia das primeiras linhas do arquivo:</p>
        <div class="excel-map-table-scroll">
          <table class="excel-map-table">
            <thead>
              <tr>
                <th *ngFor="let col of excelColunas; let i = index"
                  [class.col-marcada-pn]="excelColunaPn === i"
                  [class.col-marcada-qty]="excelColunaQty === i">
                  {{ col }}
                  <span class="col-badge pn" *ngIf="excelColunaPn === i">PN</span>
                  <span class="col-badge qty" *ngIf="excelColunaQty === i">QTD</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of excelPreviewLinhas">
                <td *ngFor="let col of excelColunas; let i = index"
                  [class.col-marcada-pn]="excelColunaPn === i"
                  [class.col-marcada-qty]="excelColunaQty === i">
                  {{ row[i] }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Resumo -->
    <div class="excel-import-resumo" *ngIf="!excelImportValidando && !excelMapeamentoAberto && excelImportLinhas.length > 0">
      <span class="resumo-total">{{ excelImportLinhas.length }} PNs lidos</span>
      <span class="resumo-ok">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
        {{ excelImportEncontrados }} encontrados
      </span>
      <span class="resumo-erro" *ngIf="excelImportNaoEncontrados > 0">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
        {{ excelImportNaoEncontrados }} não encontrados
      </span>
    </div>

    <!-- Tabela de preview (só quando não está em modo de mapeamento) -->
    <div class="excel-import-table-wrap" *ngIf="!excelImportValidando && !excelMapeamentoAberto">
      <table class="excel-import-table">
        <thead>
          <tr>
            <th class="col-check" *ngIf="excelImportOrigemOS && excelImportEncontrados > 1">
              <input type="checkbox" [checked]="excelImportEncontradosSelecionados === excelImportEncontrados"
                (change)="alternarTodosSelecionadosExcel($any($event.target).checked)" title="Selecionar todos">
            </th>
            <th class="col-status"></th>
            <th class="col-pn-excel">PN</th>
            <th class="col-desc-excel">Descrição</th>
            <th class="col-qty-excel">Qtd</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let linha of excelImportLinhas">
            <!-- Linha principal -->
            <tr [class.excel-row-ok]="linha.status === 'encontrado'"
                [class.excel-row-err]="linha.status === 'nao_encontrado'">
              <td class="col-check" *ngIf="excelImportOrigemOS && excelImportEncontrados > 1">
                <input type="checkbox" *ngIf="linha.status === 'encontrado'"
                  [(ngModel)]="linha.selecionado" [ngModelOptions]="{standalone: true}">
              </td>
              <td class="col-status">
                <svg *ngIf="linha.status === 'encontrado'" xmlns="http://www.w3.org/2000/svg"
                  width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
                <svg *ngIf="linha.status === 'nao_encontrado'" xmlns="http://www.w3.org/2000/svg"
                  width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </td>
              <td class="col-pn-excel">{{ linha.pn }}</td>
              <td class="col-desc-excel">
                <span *ngIf="linha.status === 'encontrado'">{{ linha.descricao }}</span>
                <span *ngIf="linha.status === 'nao_encontrado'" class="excel-nao-cadastrado">
                  Não cadastrado
                  <!-- botão "Ver similares" só aparece se o backend retornou aproximados -->
                  <button *ngIf="linha.proximosData && linha.proximosData.length > 0"
                    type="button" class="btn-ver-similares"
                    [class.ativo]="excelAproximadosLinha === linha"
                    (click)="toggleAproximados(linha)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                    </svg>
                    Ver similares ({{ linha.proximosData.length }})
                  </button>
                </span>
              </td>
              <td class="col-qty-excel">{{ linha.quantidade }}</td>
            </tr>
            <!-- Painel expansível de similares -->
            <tr *ngIf="excelAproximadosLinha === linha && linha.proximosData && linha.proximosData.length > 0"
                class="excel-row-similares">
              <td colspan="4" class="similares-cell">
                <div class="similares-header">Produtos similares — clique em um para usar no lugar de <strong>{{ linha.pn }}</strong>:</div>
                <div class="similares-table">
                  <div class="similares-thead">
                    <span class="sth-pn">PN</span>
                    <span class="sth-desc">Descrição</span>
                    <span class="sth-cd">CD</span>
                    <span class="sth-fab">Fabricante</span>
                  </div>
                  <button *ngFor="let p of linha.proximosData" type="button"
                    class="similar-row" (click)="selecionarAproximado(linha, p)">
                    <span class="similar-refforn">{{ p.refforn }}</span>
                    <span class="similar-desc">{{ p.descricao ?? p.descrprod }}</span>
                    <span class="similar-cd">{{ p.condicao || '—' }}</span>
                    <span class="similar-fab">{{ p.marca || '—' }}</span>
                  </button>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <!-- Rodapé: mapeamento de colunas -->
    <div class="modal-footer excel-import-footer" *ngIf="excelMapeamentoAberto && !excelImportValidando">
      <button type="button" class="modal-btn" (click)="fecharImportacaoExcel()">Cancelar</button>
      <button type="button" class="modal-btn-primary"
        [disabled]="excelColunaPn === null || excelColunaQty === null || excelColunaPn === excelColunaQty"
        (click)="confirmarMapeamento()">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
        Confirmar e validar PNs
      </button>
    </div>

    <!-- Rodapé: importação normal -->
    <div class="modal-footer excel-import-footer" *ngIf="!excelMapeamentoAberto && !excelImportGravando">
      <button type="button" class="modal-btn" (click)="fecharImportacaoExcel()">Cancelar</button>
      <button type="button" class="modal-btn-primary"
        [disabled]="excelImportValidando || excelImportando || excelImportEncontradosSelecionados === 0"
        (click)="confirmarImportacaoExcel()">
        <app-loading-indicator *ngIf="excelImportando" size="inline"></app-loading-indicator>
        <svg *ngIf="!excelImportando" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
        {{ excelImportando
            ? (excelImportOrigemOS ? 'Gravando...' : 'Importando...')
            : (excelImportOrigemOS ? 'Confirmar e gravar ' : 'Importar ')
              + excelImportEncontradosSelecionados
              + (excelImportEncontradosSelecionados === 1 ? ' item' : ' itens') }}
      </button>
    </div>

    <!-- Modal de confirmação: itens não encontrados não serão adicionados -->
    <div class="excel-confirm-overlay" *ngIf="excelAvisoNaoEncontrado" (click)="cancelarAvisoExcel()">
      <div class="excel-confirm-modal" (click)="$event.stopPropagation()">
        <div class="excel-confirm-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
        </div>
        <h3 class="excel-confirm-titulo">Itens não encontrados</h3>
        <p class="excel-confirm-msg">
          <strong>{{ excelImportNaoEncontrados }} {{ excelImportNaoEncontrados === 1 ? 'item' : 'itens' }}</strong>
          não {{ excelImportNaoEncontrados === 1 ? 'foi encontrado' : 'foram encontrados' }} no sistema
          e não {{ excelImportNaoEncontrados === 1 ? 'será adicionado' : 'serão adicionados' }} à lista de itens.<br><br>
          Deseja continuar e importar apenas
          {{ excelImportEncontrados === 1 ? 'o 1 item encontrado' : 'os ' + excelImportEncontrados + ' itens encontrados' }}?
        </p>
        <div class="excel-confirm-footer">
          <button type="button" class="modal-btn" (click)="cancelarAvisoExcel()">Não, voltar</button>
          <button type="button" class="modal-btn-primary" (click)="confirmarImportacaoExcel()">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
            Sim, importar {{ excelImportEncontrados }} {{ excelImportEncontrados === 1 ? 'item' : 'itens' }}
          </button>
        </div>
      </div>
    </div>

  </div>


</div>
